<template>
  <v-container v-if="access.includes(roles.scheduler)">
    <v-card
      class="mx-auto set-height"
    >
      <v-card-title>
        <div class="primary--text">
          Data Projection
        </div>
        <v-spacer />
        <v-btn
          color="primary"
          style="padding: 0 13px !important;"
          @click="ShowNewProjection()"
        >
          New Data Projection
        </v-btn>
        <v-btn
          color="grey darken-2"
          outlined
          @click="ShowExport()"
        >
          Export to Excel
        </v-btn>
      </v-card-title>
      <div>
        <v-data-table
          :headers="headers_document"
          :items="documents"
          :loading="loading_document"
          :options.sync="options"
          :server-items-length="total"
          :disable-sort="true"
          :loading-text="loading_text"
          class="elevation-1 text-no-wrap dense-2"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-row>
              <v-btn
                v-if="item.status=='draft'"
                small
                color="primary"
                @click.stop="GetRecords(item.uid, 0)"
              >
                Edit
              </v-btn>
              <v-btn
                v-if="item.status=='posted'"
                small
                color="teal"
                @click.stop="GetRecords(item.uid, 0)"
              >
                View
              </v-btn>
              <v-btn
                v-if="item.status=='draft'"
                small
                color="cyan"
                class="ml-2"
                @click.stop="PostDocument(item.uid)"
              >
                Post
              </v-btn>
              <v-btn
                v-if="item.status=='posted' && !item.locked"
                small
                color="orange darken-2"
                class="ml-2"
                @click.stop="UnpostDocument(item.uid)"
              >
                Unpost
              </v-btn>
              <v-btn
                v-if="item.status=='draft' && item.version==0"
                small
                color="error"
                class="ml-2"
                @click.stop="ArchiveDocument(item.uid)"
              >
                Archive
              </v-btn>
            </v-row>
          </template>
          <template v-slot:[`item.updated_at`]="{ item }">
            {{ (item.status=='posted' ? GetDateFormat(item.updated_at) : '-') }}
          </template>
          <template v-slot:[`item.file_name`]="{ item }">
            {{ (item.status=='posted' ? item.file_name : '-') }}
          </template>
          <template v-slot:[`item.file_size`]="{ item }">
            {{ (item.status=='posted' ? BytesToSize(Number(item.file_size)) : '-') }}
          </template>
          <template v-slot:[`item.version`]="{ item }">
            <v-btn
              fab
              dark
              x-small
              color="accent"
              @click.stop="ShowVersionHistory(item)"
            >
              {{ item.version }}
            </v-btn>
          </template>
        </v-data-table>
      </div>
      <v-card-title>
        <div class="primary--text">
          Schedules Summary
        </div>
      </v-card-title>
      <div>
        <v-row>
          <v-col>
            <v-sheet height="500">
              <v-progress-linear
                v-if="loading_summary"
                indeterminate
                color="primary"
              />
              <v-data-table
                :headers="headers_summary"
                :items="summary"
                :loading="loading_summary"
                :options.sync="options_summary"
                :disable-sort="true"
                :loading-text="loading_text"
                hide-default-header
                class="elevation-1 text-no-wrap sticky"
              >
                <template v-slot:header="{ props }">
                  <thead
                    :class="{ hidden: loading_summary}"
                    class="v-data-table-header"
                  >
                    <tr>
                      <th
                        :class="{ 'text-center': true, title: true }"
                        rowspan="2"
                        style="border: thin solid rgba(0, 0, 0, 0.12);"
                      >
                        <span>Store</span>
                      </th>
                      <th
                        v-for="(header, index) in headers_summary2"
                        :key="header.value + index"
                        :class="{ 'text-center': true, title: true }"
                        colspan="2"
                        style="border-top: solid thin rgba(0, 0, 0, 0.12);
                          border-right: solid thin rgba(0, 0, 0, 0.12);
                          border-bottom: solid thin rgba(0, 0, 0, 0.12);
                        "
                      >
                        <span>{{ header.text }}</span>
                      </th>
                    </tr>
                    <tr>
                      <th
                        v-for="(header, index) in props.headers"
                        :key="header.text + index"
                        :class="{ 'text-start': true, title: true, hidden: (header.text === 'Store') }"
                        style="border-right: solid thin rgba(0, 0, 0, 0.12);
                          border-bottom: solid thin rgba(0, 0, 0, 0.12);
                        "
                      >
                        <span>{{ header.text }}</span>
                      </th>
                    </tr>
                  </thead>
                </template>
                <template v-slot:body="{ items, headers }">
                  <tr
                    v-for="(item, idx) in items"
                    :key="idx"
                    style="line-height: 12px !important;font-size: 12px !important;"
                  >
                    <td
                      v-for="(header,key) in headers"
                      :key="key"
                      style="border-right: solid thin rgba(0, 0, 0, 0.12);
                        border-bottom: solid thin rgba(0, 0, 0, 0.12);
                      "
                      :class="{ customgrid: header.value !=='Store' }"
                    >
                      <strong
                        v-if="header.value ==='Store'"
                      >
                        {{ item[header.value] }}
                      </strong>
                      <strong
                        v-if="header.value !=='Store' && item[header.value] === 0"
                        class="red--text"
                      >
                        {{ item[header.value] }}
                      </strong>
                      <v-chip
                        v-if="header.value !=='Store' && item[header.value] !== 0 && header.text === 'Crew'"
                        class="ma-2 text-center"
                        color="info"
                        style="margin:0px !important; padding:0 6px!important;"
                      >
                        {{ item[header.value] }}
                      </v-chip>
                      <v-chip
                        v-if="header.value !=='Store' && item[header.value] !== 0 && header.text === 'Hours'"
                        class="ma-2"
                        color="warning"
                        style="margin:0px !important; padding:0 6px!important;"
                      >
                        {{ item[header.value] }}
                      </v-chip>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-sheet>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <div class="py-3" />

    <!-- Scheduler plot dialog -->
    <v-dialog
      v-model="show_document"
      dense
      fullscreen
      hide-overlay
      :retain-focus="false"
      transition="dialog-bottom-transition"
      persistent
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            fab
            dark
            icon
            @click.stop="drawer = !drawer"
          >
            <v-icon icon>
              mdi mdi-menu
            </v-icon>
          </v-btn>
          <v-tabs
            v-model="sched_tab"
            @change="GetRecords()"
          >
            <v-tab>MON</v-tab>
            <v-tab>TUE</v-tab>
            <v-tab>WED</v-tab>
            <v-tab>THU</v-tab>
            <v-tab>FRI</v-tab>
            <v-tab>SAT</v-tab>
            <v-tab>SUN</v-tab>
          </v-tabs>
          <v-spacer />
          <v-btn
            v-if="!posted"
            text
            loading
            :class="{hidden: !updating_break && !updating_jobrotation && !updating_expense && !updating }"
          />
          <v-btn
            v-if="!posted"
            text
            :class="{hidden: !updating_break && !updating_jobrotation && !updating_expense && !updating }"
          >
            Auto Saving Data ...
          </v-btn>
          <v-btn
            v-if="posted"
            text
            dark
            @click.stop="Print()"
          >
            <v-icon icon>
              mdi mdi-printer
            </v-icon>
            &nbsp;Print Schedule
          </v-btn>
          <v-btn
            v-if="posted"
            text
            dark
            @click="CrewTimeAvailability()"
          >
            <v-icon icon>
              mdi-calendar-account-outline
            </v-icon>
            &nbsp;Crew Time Availability
          </v-btn>
          <v-btn
            text
            dark
            :disabled="updating_break || updating_jobrotation || updating_expense || updating"
            @click="CloseDocument()"
          >
            <v-icon icon>
              mdi-close
            </v-icon>
            &nbsp;Close
          </v-btn>
        </v-toolbar>
        <v-navigation-drawer
          v-model="drawer"
          absolute
          temporary
          left
        >
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-menu</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Menu</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
          <v-list dense>
            <v-list-item
              link
              @click="drawer = false, GetJobRotation()"
            >
              <v-list-item-icon>
                <v-icon>mdi-account-star</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Job Rotation & Hours Worked</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              link
              @click="show_sales = true, drawer = false"
            >
              <v-list-item-icon>
                <v-icon>mdi-credit-card-clock</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Hourly Sales</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              link
              @click="GetRecords(), drawer = false"
            >
              <v-list-item-icon>
                <v-icon>mdi-refresh</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Refresh</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              link
              @click="CloseDocument(), drawer = false"
            >
              <v-list-item-icon>
                <v-icon>mdi-close</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Close</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-navigation-drawer>
        <v-data-table
          id="schedule"
          :headers="headers_records"
          :items="records"
          :loading="loading_records"
          :loading-text="loading_text"
          :disable-pagination="true"
          :hide-default-footer="true"
          :sort-by="['start','end']"
          height="calc(100vh - 65px)"
          fixed-header
          multi-sort
          group-by="seq"
          :group-sort="false"
          class="elevation-1 text-no-wrap record"
          dense
        >
          <template v-slot:header="{ props }">
            <thead :class="{ hidden: loading_records}">
              <tr>
                <th
                  class="text-start text-h6"
                  colspan="7"
                >
                  <div class="summary-title primary--text">
                    {{ store_name }} - {{ sales_date }}
                  </div>
                </th>
                <th
                  v-for="(header, index) in props.headers.slice(7,31)"
                  :key="header.text + index"
                  class="text-center text-h6"
                  :class="{
                    'blue-grey': (index < 7)
                      || (index > 8 && index < 11)
                      || (index > 13 && index < 16)
                      || (index > 18 && index < 25) ,
                    'orange darken-2': (index > 6 && index < 9)
                      || (index > 10 && index < 14)
                      || (index > 15 && index < 19)
                  }"
                >
                  <strong>{{ header.text }}</strong>
                </th>
              </tr>
            </thead>
            <tbody :class="{ plot: true, hidden: loading_records}">
              <tr
                class="details"
                :class="data_color"
              >
                <td
                  colspan="4"
                  rowspan="12"
                  class="plain"
                >
                  <table style="width: 100%;">
                    <tbody>
                      <tr class="no-border">
                        <td class="text-start">
                          <strong>Target NS</strong>
                        </td>
                        <td class="text-end">
                          Php{{ NumberWithComma(gross_sales/1.12) }}
                        </td>
                        <td
                          class="text-start border"
                        >
                          <strong>GCPCH Variable</strong>
                        </td>
                        <td
                          v-if="sales_count==0 || hours_summary==0"
                          class="text-end"
                        >
                          0.00
                        </td>
                        <td
                          v-if="sales_count>0 && hours_summary>0.0"
                          class="text-end"
                        >
                          {{ NumberWithComma(sales_count / hours_summary) }}
                        </td>
                      </tr>
                      <tr class="no-border">
                        <td class="text-start">
                          <strong>Target GS</strong>
                        </td>
                        <td class="text-end">
                          Php{{ NumberWithComma(gross_sales) }}
                        </td>
                        <td
                          class="text-start border"
                        >
                          <strong>GCPCH Combined</strong>
                        </td>
                        <td
                          v-if="sales_count==0 || hours_summary==0"
                          class="text-end"
                        >
                          0.00
                        </td>
                        <td
                          v-if="sales_count>0 && hours_summary>0.0"
                          class="text-end"
                        >
                          {{ NumberWithComma(sales_count / (hours_summary+fixed_hours)) }}
                        </td>
                      </tr>
                      <tr class="no-border">
                        <td class="text-start">
                          <strong>Target GC</strong>
                        </td>
                        <td class="text-end">
                          {{ sales_count }}
                        </td>
                        <td
                          class="text-start border"
                        >
                          <strong>Night Differential</strong>
                        </td>
                        <td class="text-end">
                          {{ NumberWithComma(night_diff) }}
                        </td>
                      </tr>
                      <tr class="no-border">
                        <td class="text-start">
                          <strong>Total Crew HRS</strong>
                        </td>
                        <td class="text-end">
                          {{ GetHoursSummary() + GetTotalFixedHours() }}
                        </td>
                        <td
                          class="border"
                        >
                          <strong>Additional Expense</strong>
                        </td>
                        <td
                          v-if="posted || locked"
                          class="text-end"
                        >
                          {{ NumberWithComma(expense) }}
                        </td>
                        <td
                          v-if="!posted && !locked"
                          class="ma-0 pa-0"
                        >
                          <v-text-field
                            v-model="expense"
                            single-line
                            class="text-input text-end"
                            :loading="updating_expense"
                            @keypress="ValidateInput($event)"
                            @change="UpdateExpense"
                          />
                        </td>
                      </tr>
                      <tr class="no-border">
                        <td class="text-start">
                          <strong>Total FIXED HRS</strong>
                        </td>
                        <td
                          v-if="totals.FixedHours"
                          class="text-end"
                        >
                          {{ GetTotalFixedHours() }}
                        </td>
                        <td
                          class="text-start border"
                        >
                          <strong>PROJ ACR</strong>
                        </td>
                        <td
                          v-if="labor==0.0 || hours_summary==0.0"
                          class="text-end"
                        >
                          Php0.00
                        </td>
                        <td
                          v-if="labor>0.0 && hours_summary>0.0"
                          class="text-end"
                        >
                          Php{{ NumberWithComma((labor+Number(expense))/(hours_summary+fixed_hours)) }}
                        </td>
                      </tr>
                      <tr class="no-border">
                        <td class="text-start">
                          <strong>Total VAR HRS</strong>
                        </td>
                        <td class="text-end">
                          {{ hours_summary }}
                        </td>
                        <td
                          class="text-start border"
                        >
                          <strong>PROJ LABOR</strong>
                        </td>
                        <td class="text-end">
                          Php{{ NumberWithComma((labor+Number(expense))) }}
                        </td>
                      </tr>
                      <tr class="no-border">
                        <td class="text-start">
                          <strong>AVE CHECK</strong>
                        </td>
                        <td class="text-end">
                          Php{{ NumberWithComma((gross_sales/1.12)/sales_count) }}
                        </td>
                        <td
                          class="text-start border"
                        >
                          <strong>PROJ LABOR %</strong>
                        </td>
                        <td
                          v-if="gross_sales > 0"
                          class="text-end"
                        >
                          {{ NumberWithComma((labor+Number(expense))/(gross_sales/1.12) * 100) }}%
                        </td>
                        <td
                          v-if="gross_sales == 0"
                          class="text-end"
                        >
                          0%
                        </td>
                      </tr>
                      <!-- <tr class="no-border">
                        <td colspan="4" />
                      </tr> -->
                      <tr class="no-border">
                        <td
                          colspan="4"
                          class="brown lighten-3"
                        >
                          CREW MEAL
                        </td>
                      </tr>
                      <tr class="no-border">
                        <td class="text-start">
                          <strong>MEAL A</strong>
                        </td>
                        <td class="text-end border">
                          {{ meal_a }}
                        </td>
                        <td
                          class="text-start border"
                        >
                          <strong>{{ meal_a_value }}</strong>
                        </td>
                        <td class="text-end border">
                          {{ NumberWithComma(meal_a*meal_a_value) }}
                        </td>
                      </tr>
                      <tr class="no-border">
                        <td class="text-start">
                          <strong>MEAL B</strong>
                        </td>
                        <td class="text-end border">
                          {{ meal_b }}
                        </td>
                        <td
                          class="text-start border"
                        >
                          <strong>{{ meal_b_value }}</strong>
                        </td>
                        <td class="text-end border">
                          {{ NumberWithComma(meal_b*meal_b_value) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  colspan="3"
                  class="plain"
                >
                  <strong>Sales Projected GC</strong>
                </td>
                <td
                  v-for="(n) in 24"
                  :key="n"
                >
                  <strong v-if="sales && sales.length > 0">
                    {{ sales[n-1].HSPTAC > 0 ? sales[n-1].HSPTAC : '' }}
                  </strong>
                </td>
              </tr>
              <tr
                v-if="user_inputs.total_gc"
                class="details"
                :class="input_color"
              >
                <td
                  colspan="3"
                  class="plain"
                >
                  <strong class="primary--text">Actual GC</strong>
                </td>
                <td
                  v-for="(u, i) in user_inputs.total_gc[0]"
                  :key="i"
                >
                  <v-text-field
                    v-if="!posted && !locked"
                    v-model="user_inputs.total_gc[0][i]"
                    single-line
                    class="text-input"
                    :loading="updating && (edited_index === i && edited_name === 'total_gc')"
                    @keypress="ValidateInput($event)"
                    @keydown="edited_index = i, edited_name = 'total_gc', is_changed = true"
                    @change="SaveInput"
                  />
                  <strong v-if="posted || locked">{{ u }}</strong>
                </td>
              </tr>
              <tr
                v-if="sales && sales.length > 0 && user_inputs.total_gc"
                class="border-bottom details"
                :class="entry_color"
              >
                <td
                  colspan="3"
                  class="plain"
                >
                  <strong>Difference</strong>
                </td>
                <td
                  v-for="(n) in 24"
                  :key="n"
                >
                  <strong>{{ GetTotalDifference(n-1) }}</strong>
                </td>
              </tr>
              <tr
                class="border-bottom row-separator"
                :class="separator_color"
              >
                <td colspan="28" />
              </tr>
              <tr
                v-if="totals"
                class="border-bottom details"
                :class="entry_color"
              >
                <td
                  colspan="3"
                  class="plain"
                >
                  <strong>Total Variable Hours Projected</strong>
                </td>
                <td
                  v-for="(n) in 24"
                  :key="n"
                >
                  <strong>{{ GetTotalHours(n-1) }}</strong>
                </td>
              </tr>
              <tr
                v-if="user_inputs.total_hours"
                class="border-bottom details"
                :class="input_color"
              >
                <td
                  colspan="3"
                  class="plain"
                >
                  <strong class="primary--text">Actual Hours</strong>
                </td>
                <td
                  v-for="(u, i) in user_inputs.total_hours[0]"
                  :key="i"
                >
                  <v-text-field
                    v-if="!posted && !locked"
                    v-model="user_inputs.total_hours[0][i]"
                    single-line
                    class="text-input"
                    :loading="updating && (edited_index === i && edited_name === 'total_hours')"
                    @keypress="ValidateInput($event)"
                    @keydown="edited_index = i, edited_name = 'total_hours', is_changed = true"
                    @change="SaveInput"
                  />
                  <strong v-if="posted || locked">{{ u }}</strong>
                </td>
              </tr>
              <tr
                class="border-bottom row-separator"
                :class="separator_color"
              >
                <td colspan="28" />
              </tr>
              <tr
                v-if="sales && sales.length > 0 && totals"
                class="border-bottom details"
                :class="entry_color"
              >
                <td
                  colspan="3"
                  class="plain"
                >
                  <strong>Projected GCPCH Variable</strong>
                </td>
                <td
                  v-for="(n) in 24"
                  :key="n"
                >
                  <strong>{{ GetCombinedGC(n-1) }}</strong>
                </td>
              </tr>
              <tr style="height: 32px">
                <td
                  colspan="28"
                  style="border-bottom-style: none !important;"
                />
              </tr>
              <tr style="height: 100%">
                <td
                  colspan="28"
                >
                  <v-row>
                    <v-col
                      cols="12"
                      sm="4"
                    >
                      <strong style="color:black;border-top:1px solid">&nbsp;&nbsp;Restaurant Manager&nbsp;&nbsp;</strong>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="4"
                    >
                      <strong style="color:black;border-top:1px solid">&nbsp;&nbsp;Scheduling Manager&nbsp;&nbsp;</strong>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="4"
                    />
                  </v-row>
                </td>
              </tr>
            </tbody>
          </template>
          <template v-slot:group="{ group, items, headers }">
            <!-- Print column headers if posted -->
            <tr v-if="items[0]['primary'] && posted && ShowSales(items[0]['channel'])">
              <th
                v-for="(header, index) in headers"
                :key="header.text + index"
                :style="{'color': 'rgba(0, 0, 0, 0.6)','padding': '0 8px','border-bottom': 'thin solid rgba(0, 0, 0, 0.12) !important'}"
                :class="{
                  'text-start title brown lighten-3': (index < 7),
                  'text-center blue-grey': (index > 6 && index < 14)
                    || (index > 15 && index < 18)
                    || (index > 20 && index < 23)
                    || (index > 25 && index < 32) ,
                  'text-center orange darken-2': (index > 13 && index < 16)
                    || (index > 17 && index < 21)
                    || (index > 22 && index < 26)
                }"
              >
                <span>{{ header.text }}</span>
              </th>
            </tr>
            <!-- Print column headers if posted -->
            <!-- Business Extension Summary -->
            <tr
              v-if="items[0]['primary'] && ShowSales(items[0]['channel'])"
              class="border-bottom details"
              :class="data_color"
            >
              <td
                colspan="4"
                rowspan="5"
                class="plain no-padding"
              >
                <table style="width: 100%;">
                  <th
                    class="text-start text-h6"
                    colspan="4"
                  >
                    <div class="summary-title primary--text">
                      {{ GetChannelDescription(items[0]['channel']) }}
                    </div>
                  </th>
                  <tbody>
                    <tr class="no-border">
                      <td><strong>Gross Sales</strong></td>
                      <td class="text-end">
                        {{ NumberWithComma(GetSales(items[0]['channel'])) }}
                      </td>
                      <td
                        class="border"
                      >
                        <strong>GCPCH</strong>
                      </td>
                      <td
                        v-if="GetExtensionTotalHours(items[0]['channel'])==0"
                        class="text-end"
                      >
                        0.00
                      </td>
                      <td
                        v-if="GetExtensionTotalHours(items[0]['channel'])>0"
                        class="text-end"
                      >
                        {{ NumberWithComma(GetGuestCount(items[0]['channel'])/GetExtensionTotalHours(items[0]['channel'])) }}
                      </td>
                    </tr>
                    <tr class="no-border">
                      <td><strong>Ave Check</strong></td>
                      <td class="text-end">
                        {{ NumberWithComma(GetSales(items[0]['channel'])/GetGuestCount(items[0]['channel'])) }}
                      </td>
                      <td
                        class="border"
                      >
                        <strong>SCPMH</strong>
                      </td>
                      <td
                        v-if="GetExtensionTotalHours(items[0]['channel'])==0"
                        class="text-end"
                      >
                        0.00
                      </td>
                      <td
                        v-if="GetExtensionTotalHours(items[0]['channel'])>0"
                        class="text-end"
                      >
                        {{ NumberWithComma(GetSales(items[0]['channel'])/GetExtensionTotalHours(items[0]['channel'])) }}
                      </td>
                    </tr>
                    <tr class="no-border">
                      <td><strong>Total Crew HRS</strong></td>
                      <td class="text-end">
                        {{ GetExtensionTotalHours(items[0]['channel']) }}
                      </td>
                      <td
                        class="border"
                      >
                        <strong>Total GC</strong>
                      </td>
                      <td class="text-end">
                        {{ GetGuestCount(items[0]['channel']) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td
                colspan="3"
                class="plain"
              >
                <strong>{{ GetChannelDescription(items[0]['channel']) }} Projected GC</strong>
              </td>
              <td
                v-for="(n) in 24"
                :key="n"
              >
                <strong v-if="sales && sales.length > 0">
                  {{ GetSalesCount(n-1, items[0]['channel']) }}
                </strong>
              </td>
            </tr>
            <tr
              v-if="items[0]['primary'] && user_inputs[items[0]['channel'].toLowerCase()] && ShowSales(items[0]['channel'])"
              class="border-bottom details"
              :class="input_color"
            >
              <td
                colspan="3"
                class="plain"
              >
                <strong class="primary--text">Actual GC</strong>
              </td>
              <td
                v-for="(u, i) in user_inputs[items[0]['channel'].toLowerCase()][0]"
                :key="i"
              >
                <v-text-field
                  v-if="!posted && !locked"
                  v-model="user_inputs[items[0]['channel'].toLowerCase()][0][i]"
                  single-line
                  class="text-input"
                  :loading="updating && (edited_index === i && edited_name === items[0]['channel'])"
                  @keypress="ValidateInput($event)"
                  @keydown="edited_index = i, edited_name = items[0]['channel'], is_changed = true"
                  @change="SaveInput"
                />
                <strong v-if="posted || locked">{{ u }}</strong>
              </td>
            </tr>
            <tr
              v-if="items[0]['primary'] && ShowSales(items[0]['channel'])"
              class="border-bottom details"
              :class="entry_color"
            >
              <td
                colspan="3"
                class="plain"
              >
                <strong>Difference</strong>
              </td>
              <td
                v-for="(n) in 24"
                :key="n"
              >
                <strong v-if="sales && sales.length > 0 && user_inputs[items[0]['channel'].toLowerCase()]">
                  {{ GetDifference(n-1, items[0]['channel']) }}
                </strong>
              </td>
            </tr>
            <tr
              v-if="items[0]['primary'] && ShowSales(items[0]['channel'])"
              class="border-bottom details"
              :class="data_color"
            >
              <td
                colspan="3"
                class="plain"
              >
                <strong>Variable Hours Projected</strong>
              </td>
              <td
                v-for="(n) in 24"
                :key="n"
              >
                <strong v-if="sales && sales.length > 0">
                  {{ GetVariableHours(n-1, items[0]['channel']) }}
                </strong>
              </td>
            </tr>
            <tr
              v-if="items[0]['primary'] && totals[items[0]['channel']] && ShowSales(items[0]['channel'])"
              class="border-bottom details"
              :class="entry_color"
            >
              <td
                colspan="3"
                class="plain"
              >
                <strong>Actual Variable Hours</strong>
              </td>
              <td
                v-for="(u, i) in totals[items[0]['channel']][0]"
                :key="i"
              >
                <strong>{{ u === 0 ? '' : u }}</strong>
              </td>
            </tr>
            <!-- End Business Extension Summary -->
            <!-- Managers/Fixed hours -->
            <tr
              v-if="items[0]['primary'] && ShowSales(items[0]['channel']) === false"
              class="border-bottom details"
              :class="separator_color"
            >
              <td
                colspan="4"
                class="plain"
              />
              <td
                colspan="3"
                class="plain"
              >
                <strong>Total {{ GetChannelDescription(items[0]['channel']) }} Hours</strong>
              </td>
              <td
                v-for="(u, i) in totals[items[0]['channel']][0]"
                :key="i"
              >
                <strong>{{ u === 0 ? '' : u }}</strong>
              </td>
            </tr>
            <!-- End fixed hours -->

            <tr class="teal">
              <td>
                <strong>
                  {{ group.substring(1, group.length).toUpperCase() }}
                </strong>
              </td>
              <td>
                <v-btn
                  v-if="!posted && !locked"
                  color="teal darken-3"
                  class="no-case"
                  small
                  @click="ShowCrew(items[0])"
                >
                  Add {{ items[0]['trained_area_id'] === 1 ? 'Manager' : 'Crew' }}
                </v-btn>
              </td>
              <td colspan="30" />
            </tr>
            <tr
              v-for="(item) in items"
              :key="item.uid"
              :class="{ 'plot': true , hidden: IsRecord(item.personnelidno) }"
            >
              <v-tooltip
                color="primary"
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <td
                    class="text-left"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <span
                      v-if="posted || locked || item.week_day_id!=item.wid"
                    >
                      {{ item.nick_name }}
                      <v-icon
                        small
                        color="teal"
                      >
                        {{ GetIconMultiple(item) }}
                      </v-icon>
                      <v-chip
                        v-if="item.week_day_id!=item.wid"
                        class="ma-2"
                        color="info"
                        style="margin:0px !important; padding:0 6px!important;"
                        x-small
                      >
                        {{ GetDay() }}
                      </v-chip>
                    </span>
                    <a
                      v-if="!posted && !locked && item.week_day_id==item.wid"
                      style="color: inherit;"
                      @click="DeleteRecord(item)"
                    >
                      {{ item.nick_name }}
                      <v-icon
                        small
                        color="teal"
                      >
                        {{ GetIconMultiple(item) }}
                      </v-icon>
                      <v-icon
                        small
                        color="error"
                      >
                        mdi mdi-close
                      </v-icon>
                    </a>
                  </td>
                </template>
                <span>{{ item.personnelidno + ' ' + item.name }}</span>
              </v-tooltip>
              <td>{{ item.job_rotation }}</td>
              <td class="text-left ma-0 pa-0">
                <span v-if="posted || locked || item.week_day_id!=item.wid">
                  {{ item.break }}
                </span>
                <v-text-field
                  v-if="!posted && !locked && item.week_day_id==item.wid"
                  v-model="item.break"
                  single-line
                  class="text-input"
                  :loading="edited_item.uid == item.uid && updating_break"
                  @keydown="edited_item = item"
                  @change="UpdateBreak"
                />
              </td>
              <td v-if="posted || locked || item.week_day_id!=item.wid">
                {{ item.time_availability }}
              </td>
              <a
                v-if="!posted && !locked && item.week_day_id==item.wid"
                style="color: inherit;"
                @click.stop="EditSchedule(item)"
              >
                <td>
                  {{ item.time_availability }}
                  <v-icon
                    small
                    :color="GetEditScheduleColor(item)"
                  >
                    mdi-clock-check-outline
                  </v-icon>
                </td>
              </a>
              <td>{{ item.position_code }}</td>
              <!-- <td>{{ NumberWithComma1(item.hours) }}</td> -->
              <v-tooltip
                color="warning"
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <td
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-chip
                      x-small
                      outlined
                      class="ma-2"
                      color="warning"
                      style="margin:0px !important; padding:0 6px!important;"
                    >
                      <span>
                        {{ NumberWithComma1(item.hours) }}
                      </span>
                    </v-chip>
                  </td>
                </template>
                <span>Schedule: {{ item.schedule }}</span>
              </v-tooltip>
              <td>{{ item.meal }}</td>
              <td
                v-for="(n) in 24"
                :key="n"
              >
                <strong>
                  {{
                    GetPlot(item, n)
                  }}
                </strong>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
    <!-- End scheduler plot dialog -->

    <!-- Crew selection dialog -->
    <v-dialog
      v-model="show_crew"
      width="70%"
      max-width="70%"
    >
      <v-card>
        <v-card-title class="text-start">
          <h2 class="primary--text">
            {{ crew_title }}
          </h2>
        </v-card-title>
        <v-form
          ref="crew_schedule"
          lazy-validation
        >
          <v-card-text>
            <v-col
              cols="6"
            >
              <v-autocomplete
                v-model="select_station"
                :loading="loading_stations"
                :items="stations"
                item-text="name"
                item-value="key_code"
                flat
                hide-no-data
                hide-details
                dense
                min-width="0"
                label="Select Station"
                multiple
                :count="2"
                :rules="[
                  v => !!v || 'This is required'
                ]"
              />
            </v-col>
            <v-data-table
              v-if="!show_manager"
              :headers="headers_available_crew"
              :items="crew_filtered"
              :loading="loading_available_crew"
              :loading-text="loading_text"
              :disable-sort="true"
              :disable-pagination="true"
              :hide-default-footer="true"
              class="elevation-1 text-no-wrap dense-2"
            >
              <template v-slot:[`item.time_availability`]="{ item }">
                {{ item.start + '-' + item.end }}
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <div class="row">
                  <v-btn
                    small
                    :color="GetStationFilterColor()"
                    :disabled="!IsSelectable(item)"
                    @click.stop="CreateRecord(item, crew_hash)"
                  >
                    Select
                  </v-btn>
                </div>
              </template>
            </v-data-table>
            <v-data-table
              v-if="show_manager"
              :headers="headers_employees"
              :items="employees"
              :loading="loading_employees"
              :loading-text="loading_text"
              :disable-pagination="true"
              :hide-default-footer="true"
              class="elevation-1 text-no-wrap dense-2"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <div class="row">
                  <v-btn
                    small
                    :color="GetStationFilterColor()"
                    :disabled="!IsSelectable(item)"
                    @click.stop="CreateRecord(item, employees_hash)"
                  >
                    Select
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-form>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="show_crew = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End crew selection dialog -->

    <!-- Generate projection dialog -->
    <v-dialog
      v-model="show_generate_projection"
      width="30%"
      max-width="40%"
    >
      <v-card>
        <v-card-title class="text-left">
          <h2 class="primary--text">
            Select Starting Date
          </h2>
        </v-card-title>
        <v-card-text>
          <v-col
            cols="12"
            sm="10"
          >
            <v-menu
              v-model="date_menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="starting_date"
                  label="Starting Date"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="starting_date"
                @input="OnDateInput"
              />
            </v-menu>
          </v-col>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            :disabled="in_process"
            @click="GenerateProjection"
          >
            Generate
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="in_process"
            @click="show_generate_projection = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End generate projection dialog -->

    <!-- Crew Time Availability dialog -->
    <v-dialog
      v-model="show_crew_time_availability"
      fullscreen
      :retain-focus="false"
      transition="dialog-bottom-transition"
    >
      <v-card id="crewTA">
        <v-toolbar
          color="primary"
          dark
        >
          <h2>{{ store_name }} - {{ sales_date }} [Crew Time Availability]</h2>
          <v-spacer />
          <v-toolbar-items
            id="printmenu"
            class="hidden-sm-and-down"
          >
            <v-btn
              v-if="posted"
              text
              @click.stop="PrintTA()"
            >
              <v-icon icon>
                mdi mdi-printer
              </v-icon>
              &nbsp;Print
            </v-btn>
            <v-btn
              text
              @click="show_crew_time_availability=false"
            >
              <v-icon icon>
                mdi-close
              </v-icon>
              &nbsp;Close
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-data-table
            :headers="headers_crew_time_availability"
            :items="crew_time_availability"
            :loading="loading_crew_time_availability"
            :loading-text="loading_text"
            :disable-sort="true"
            :disable-pagination="true"
            :hide-default-footer="true"
            class="elevation-1 text-no-wrap dense-2 ta-table"
          >
            <template v-slot:item="{ item, index }">
              <tr
                v-if="totals.TA && index === 0"
                class="details"
              >
                <td class="text-center">
                  <b>Number of Crew</b>
                </td>
                <td
                  v-for="(u, i) in totals.TA[0]"
                  :key="i"
                  class="text-center"
                >
                  {{ u === 0 ? '' : u }}
                </td>
              </tr>
              <tr class="details">
                <td
                  class="text-start"
                  style="height: 38px;"
                >
                  {{ item.name }}
                </td>
                <td
                  v-for="(n) in 24"
                  :key="n"
                  style="padding: 0 !important;max-width:18px;height: 38px;"
                >
                  <v-col
                    v-if="GetPlotTA(item,n) === '1'"
                    cols="12"
                    class="primary box"
                    style="height: 12px"
                  >
                    &nbsp;
                  </v-col>
                  <v-col
                    v-if="GetPlotTA(item,n) === 'h1'"
                    style="display: flex;padding: 0 !important; clear:both;"
                  >
                    <v-col
                      style="flex: 50%;height: 12px"
                      class="box"
                    >
                      &nbsp;
                    </v-col>
                    <v-col
                      style="flex: 50%;height: 12px"
                      class="primary box"
                    >
                      &nbsp;
                    </v-col>
                  </v-col>
                  <v-col
                    v-if="GetPlotTA(item,n) === 'h2'"
                    style="display: flex;padding: 0 !important; clear:both;"
                  >
                    <v-col
                      style="flex: 50%;height: 12px"
                      class="primary box"
                    >
                      &nbsp;
                    </v-col>
                    <v-col
                      style="flex: 50%;height: 12px"
                      class="box"
                    >
                      &nbsp;
                    </v-col>
                  </v-col>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End Crew Time Availability dialog -->

    <!-- Hourly Sales dialog -->
    <v-dialog
      v-model="show_sales"
      fullscreen
      :retain-focus="false"
      transition="dialog-bottom-transition"
    >
      <v-card id="hourlysales">
        <v-toolbar
          color="primary"
          dark
        >
          <h2>Hourly Sales</h2>
          <v-spacer />
          <v-toolbar-items
            id="printmenu"
            class="hidden-sm-and-down"
          >
            <v-btn
              v-if="posted"
              text
              @click.stop="PrintHourlySales()"
            >
              <v-icon icon>
                mdi mdi-printer
              </v-icon>
              &nbsp;Print
            </v-btn>
            <v-btn
              text
              @click="show_sales=false"
            >
              <v-icon icon>
                mdi-close
              </v-icon>
              &nbsp;Close
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-data-table
            :headers="headers_sales"
            :items="sales"
            :loading="loading_records"
            :loading-text="loading_text"
            :disable-sort="true"
            :disable-pagination="true"
            :hide-default-footer="true"
            class="elevation-1 text-no-wrap dense-2"
          >
            <template v-slot:[`item.HSPTIM`]="{ item }">
              {{ FormatTime('0000'.substring(0, 4 - item.HSPTIM.length) + item.HSPTIM) }}
            </template>
            <template v-slot:[`item.HSPSAG`]="{ item }">
              <span class="text-right">{{ NumberWithComma(item.HSPSAG) }}</span>
            </template>
            <template v-slot:[`item.HSPSFC`]="{ item }">
              <span class="text-right">{{ NumberWithComma(item.HSPSFC) }}</span>
            </template>
            <template v-slot:[`item.HSPSDT`]="{ item }">
              <span class="text-right">{{ NumberWithComma(item.HSPSDT) }}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End Hourly Sales dialog -->

    <!-- JobRotation dialog -->
    <v-dialog
      v-model="show_jobrotation"
      fullscreen
      :retain-focus="false"
      transition="dialog-bottom-transition"
    >
      <v-card id="hoursworked">
        <v-toolbar
          color="primary"
          dark
        >
          <h2>{{ store_name }} - {{ GetDateRange() }} [Job Rotation & Hours Worked]</h2>
          <v-spacer />
          <v-toolbar-items
            id="printmenu"
            class="hidden-sm-and-down"
          >
            <v-btn
              v-if="posted"
              text
              @click.stop="PrintHoursWorked()"
            >
              <v-icon icon>
                mdi mdi-printer
              </v-icon>
              &nbsp;Print
            </v-btn>
            <v-btn
              text
              @click="show_jobrotation=false"
            >
              <v-icon icon>
                mdi-close
              </v-icon>
              &nbsp;Close
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-data-table
            :headers="headers_jobrotation"
            :items="jobrotation"
            :loading="loading_jobrotation"
            :loading-text="loading_text"
            :disable-sort="true"
            :disable-pagination="true"
            :hide-default-footer="true"
            class="elevation-1 text-no-wrap dense-2"
          />
        </v-card-text>
        <v-card-title class="text-left">
          <h2>
            List of Crew Without Schedule
          </h2>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers_without_schedule"
            :items="without_schedule"
            :loading="loading_jobrotation"
            :loading-text="loading_text"
            :disable-sort="true"
            :disable-pagination="true"
            :hide-default-footer="true"
            class="elevation-1 text-no-wrap dense-2"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End JobRotation dialog -->

    <!-- Adjust schedule dialog -->
    <v-dialog
      v-model="show_adjust"
      width="70%"
      max-width="70%"
    >
      <v-card>
        <v-toolbar
          color="primary"
          dark
          dense
          flat
        >
          <v-toolbar-title class="white--text">
            Adjust schedule - {{ description }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pb-0">
          <v-col class="pb-12 pt-0 mt-2">
            Time Availability : &nbsp;
            <v-chip
              class="ma-2"
              color="info"
            >
              {{ nick_name }}
            </v-chip>
            <v-chip
              class="ma-2"
              color="warning"
            >
              {{ time_availability }}
            </v-chip>
            <v-chip
              class="ma-2"
              color="primary"
            >
              {{ GetTimeSpanTA(time_availability) }} hrs
            </v-chip>
            <v-btn
              v-if="edited_items"
              color="blue-grey"
              text
              outlined
              small
              @click.stop="show_adjust=false, ShowAdvancePlot()"
            >
              Advance Plot
              <v-icon
                right
                dark
              >
                mdi-pencil
              </v-icon>
            </v-btn>
            <v-checkbox
              v-if="edited_item"
              v-model="cross_schedule"
              label="Cross Schedule"
              :readonly="disable_cross_schedule"
              :class="{ hidden: !cross_schedule && edited_item.trained_area_id !=1 }"
            />
          </v-col>
          <v-divider />
          <v-col
            v-if="!edited_items"
            cols="12"
          >
            <v-range-slider
              v-model="slider"
              label="Time Range :"
              thumb-label="always"
              :track-color="GetSliderTrackColor()"
              :thumb-size="38"
              step="0.5"
              :min="cross_schedule ? 18 : 0"
              :max="cross_schedule ? 32 : 24"
            >
              <template v-slot:thumb-label="{ value }">
                {{ GetIntToTime(value) }}
              </template>
              <template v-slot:append>
                <v-text-field
                  :value="(slider[1] - slider[0]) + ' hrs'"
                  class="mt-0 pt-0"
                  hide-details
                  single-line
                  style="width: 50px"
                  readonly
                />
              </template>
            </v-range-slider>
          </v-col>
          <v-col
            v-if="edited_items"
            cols="12"
          >
            <v-row
              v-for="(s, i) in sliders"
              :key="i"
            >
              <v-col cols="2">
                {{ edited_items[i].trained_area }}
              </v-col>
              <v-col
                cols="10"
              >
                <v-range-slider
                  v-model="sliders[i]"
                  thumb-label="always"
                  :track-color="GetSliderTrackColor()"
                  label=":"
                  :thumb-size="38"
                  step="0.5"
                  :min="cross_schedule ? 18 : 0"
                  :max="cross_schedule ? 32 : 24"
                >
                  <template v-slot:thumb-label="{ value }">
                    {{ GetIntToTime(value) }}
                  </template>
                  <template v-slot:append>
                    <v-text-field
                      :value="(sliders[i][1] - sliders[i][0]) + ' hrs'"
                      class="mt-0 pt-0"
                      hide-details
                      single-line
                      style="width: 50px"
                      readonly
                    />
                  </template>
                </v-range-slider>
              </v-col>
            </v-row>
          </v-col>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer />
          <v-btn
            color="primary darken-1"
            text
            :disabled="!IsScheduleValid()"
            @click.stop="ValidateSchedule()"
          >
            Apply
          </v-btn>
          <v-btn
            color="grey"
            text
            @click.stop="show_adjust=false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End adjust schedule dialog -->

    <!-- Advance edit dialog -->
    <v-dialog
      v-model="show_advance_plot"
      width="90%"
      max-width="90%"
    >
      <v-card>
        <v-card-title class="text-start">
          <h2 class="primary--text">
            Advance Schedule Plotting
          </h2>
        </v-card-title>
        <v-card-text>
          <v-col class="pb-4 pt-0 mt-2">
            Time Availability : &nbsp;
            <v-chip
              class="ma-2"
              color="info"
            >
              {{ nick_name }}
            </v-chip>
            <v-chip
              class="ma-2"
              color="warning"
            >
              {{ time_availability }}
            </v-chip>
            <v-chip
              class="ma-2"
              color="primary"
            >
              {{ GetTimeSpanTA(time_availability) }} hrs
            </v-chip>
          </v-col>
          <v-divider />
          <v-col class="px-0">
            <v-data-table
              dense
              :headers="headers_advance_plot"
              :items="advance_plot_input"
              :loading-text="loading_text"
              :disable-sort="true"
              :disable-pagination="true"
              :hide-default-footer="true"
              class="elevation-1 text-no-wrap dense-2"
            >
              <template v-slot:body="{ items, headers }">
                <tr
                  v-for="(item, idx) in items"
                  :key="idx"
                  class="details"
                >
                  <td
                    v-for="(header,key) in headers"
                    :key="key"
                  >
                    <v-btn
                      v-if="header.value!='trained_area'"
                      small
                      text
                      style="min-width: 30px"
                      :disabled="!(parseInt(header.value) >= min_plot && parseInt(header.value) < max_plot)"
                      :class="{'green lighten-5': (parseInt(header.value) >= min_plot && parseInt(header.value) < max_plot)
                      }"
                      @click="SetValueOnClick(idx, 'p' + header.value)"
                    >
                      {{ item['p' + header.value] }}
                    </v-btn>
                    <span
                      v-if="header.value=='trained_area'"
                    >
                      {{ item['trained_area'].toUpperCase() }}
                    </span>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            :disabled="!isplot_valid"
            @click="SaveAdvancePlot"
          >
            Save
          </v-btn>
          <v-btn
            color="grey"
            text
            @click="show_advance_plot = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End advance edit dialog -->

    <!-- Export to Excel dialog -->
    <v-dialog
      v-model="show_export"
      width="40%"
      max-width="40%"
    >
      <v-card>
        <v-card-title class="text-left">
          <h2 class="primary--text">
            Export To Excel
          </h2>
        </v-card-title>
        <v-card-text>
          <v-col
            cols="12"
            sm="10"
          >
            <v-text-field
              v-model="personnelidno"
              clearable
              :counter="10"
              :rules="[
                v => v.length ==0 || (v.length == 10 && /^\d*$/.test(v)) || 'Must be 10 characters long, all numeric.'
              ]"
            >
              <template v-slot:label>
                <div>
                  PERSONNELIDNO <small>(optional)</small>
                </div>
              </template>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            sm="10"
          >
            <v-menu
              v-model="date_menu_from"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date_from"
                  label="Date From"
                  readonly
                  required
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="date_from"
                @input="OnDateInput"
              />
            </v-menu>
            <v-menu
              v-model="date_menu_to"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date_to"
                  label="Date To"
                  readonly
                  required
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="date_to"
                @input="OnDateInput"
              />
            </v-menu>
          </v-col>
          <v-btn
            color="green darken-1"
            text
            plain
            style="text-decoration: underline;opacity:1;"
            :class="{ hidden: filename == ''}"
            :disabled="in_process"
            :href="filename"
            target="_blank"
            download
          >
            Download File
          </v-btn>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            v-if="generating"
            color="green darken-1"
            text
            loading
          />
          <v-btn
            color="green darken-1"
            text
            :disabled="generating"
            @click="ExportToExcel()"
          >
            Generate
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="generating"
            @click="show_export = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Export to Excel dialog -->

    <!-- Version History dialog -->
    <v-dialog
      v-model="show_version_history"
      fullscreen
      :retain-focus="false"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          color="accent"
          dark
        >
          <v-btn icon>
            <v-icon>mdi-history</v-icon>
          </v-btn>
          <v-toolbar-title>Version History</v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            @click="show_version_history = false"
          >
            <v-icon icon>
              mdi-close
            </v-icon>
            &nbsp;Close
          </v-btn>
          <div />
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col
              cols="9"
            >
              <v-data-table
                :headers="headers_document_history"
                :items="document_history"
                :loading="loading_document_history"
                :disable-sort="true"
                :loading-text="loading_text"
                class="elevation-1 text-no-wrap dense-2"
              >
                <template v-slot:[`item.posted_at`]="{ item }">
                  {{ GetDateFormat(item.posted_at) }}
                </template>
                <template v-slot:[`item.unposted_at`]="{ item }">
                  {{ GetDateFormat(item.unposted_at) }}
                </template>
                <template v-slot:[`item.created_at`]="{ item }">
                  {{ GetDateFormat(item.created_at) }}
                </template>
                <template v-slot:[`item.updated_at`]="{ item }">
                  {{ GetDateFormat(item.updated_at) }}
                </template>
              </v-data-table>
            </v-col>
            <v-col
              cols="3"
            >
              <v-skeleton-loader
                v-if="loading_document_history && version_list.length===0"
                type="table-heading, list-item-three-line"
              />
              <v-list v-if="version_list.length>0">
                <v-list-item-group
                  v-model="selected_item"
                  color="accent"
                  mandatory
                  @change="ReloadHistory()"
                >
                  <header>File # {{ (reference_number == 0) ? '' : reference_number }}</header>
                  <v-list-item v-if="version_list.length>0">
                    <v-list-item-content>
                      <v-list-item-subtitle
                        style="font-weight: 700;"
                      >
                        {{ version_list[0].date }}
                      </v-list-item-subtitle>
                      <v-list-item-title
                        v-if="version_list[0].status === 'posted'"
                        style="color: #00bcd4;"
                      >
                        Posted
                      </v-list-item-title>
                      <v-list-item-title
                        v-if="version_list[0].status === 'draft'"
                        style="color: #4caf50;"
                      >
                        Draft
                      </v-list-item-title>
                      <li style="display:list-item;">
                        <span style="position: relative;left: -10px;font-size: 13px;font-style:italic;">Current Version</span>
                      </li>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-icon
                        v-if="version_list[0].status === 'posted'"
                        color="cyan"
                      >
                        mdi-checkbox-marked-circle
                      </v-icon>
                      <v-icon
                        v-if="version_list[0].status === 'draft'"
                        color="primary"
                      >
                        mdi-pencil-box-multiple-outline
                      </v-icon>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider />
                  <v-list-item v-if="version_list.length>1">
                    <v-list-item-content>
                      <v-list-item-subtitle
                        style="font-weight: 700;"
                      >
                        {{ version_list[1].date }}
                      </v-list-item-subtitle>
                      <v-list-item-title
                        style="color: #f9a825;"
                      >
                        Unposted
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-icon
                        color="yellow darken-3"
                      >
                        mdi-alert-box-outline
                      </v-icon>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider />
                  <v-list-item v-if="version_list.length>2">
                    <v-list-item-content>
                      <v-list-item-subtitle
                        style="font-weight: 700;"
                      >
                        {{ version_list[2].date }}
                      </v-list-item-subtitle>
                      <v-list-item-title
                        style="color: #f9a825;"
                      >
                        Unposted
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-icon
                        color="yellow darken-3"
                      >
                        mdi-alert-box-outline
                      </v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End version history dialog -->

    <confirm ref="confirm" />
  </v-container>
</template>
<script>
  import moment from 'moment'
  import {
    mapState,
  } from 'vuex'
  import {
    Documents,
    DocumentRecords,
    CreateDocument,
    CreateRecord,
    DeleteRecord,
    UpdateUserInput,
    UpdateSchedule,
    UpdateScheduleMultiple,
    UpdateScheduleAdvance,
    UpdateBreak,
    PostDocument,
    UnpostDocument,
    ArchiveDocument,
    GetScheduleSummary,
    DocumentHistory,
  } from '@/graphql/Document.gql'
  import {
    AvailableCrew,
    CrewTimeAvailability,
  } from '@/graphql/Crew.gql'
  import {
    GetJobRotation,
  } from '@/graphql/JobRotation.gql'
  import {
    GetManagers,
  } from '@/graphql/Employee.gql'
  import {
    ExportToExcel,
  } from '@/graphql/File.gql'
  export default {
    components: {
      Confirm: () => import('@/views/dashboard/component/Confirm'),
    },
    data () {
      return {
        // rebuild
        store_name: "McDonald's",
        sched_tab: 0,
        documents: [],
        document_history: [],
        records: [],
        sales: [],
        available_crew: [],
        crew_time_availability: [],
        employees: [],
        business_extensions: [],
        day_parts: [],
        variable_hours: [],
        summary: [],
        week_day_id: 1,
        week_day_values: [2, 3, 4, 5, 6, 7, 1], // mssql
        // week_day_values: [1, 2, 3, 4, 5, 6, 7], // mysql
        trained_area_id: 0,
        trained_area: '',
        loading_text: 'Please wait while loading data...',
        headers_document: [
          { text: 'File #', value: 'ref', class: 'title' },
          { text: 'Starting Date', value: 'date', class: 'title' },
          { text: 'Created By', value: 'nick_name', class: 'title' },
          { text: 'Date Created', value: 'created_at', class: 'title' },
          { text: 'Actions', value: 'actions', class: 'title' },
          { text: 'Date & Time Posted', value: 'updated_at', class: 'title' },
          { text: 'Filename', value: 'file_name', class: 'title' },
          { text: 'File Size', value: 'file_size', class: 'title' },
          { text: 'Version', value: 'version', class: 'title' },
        ],
        headers_document_history: [
          { text: 'PERSONNELIDNO', value: 'personnelidno', class: 'title' },
          { text: 'Crew Name', value: 'crew_name', class: 'title' },
          { text: 'Date', value: 'date', class: 'title' },
          { text: 'Shift', value: 'shift', class: 'title' },
          { text: 'Hours', value: 'hours', class: 'title', align: 'center' },
          { text: 'Date Posted', value: 'posted_at', class: 'title' },
          { text: 'Date Unposted', value: 'unposted_at', class: 'title' },
          { text: 'Date Created', value: 'created_at', class: 'title' },
          { text: 'Date Updated', value: 'updated_at', class: 'title' },
          { text: 'Version', value: 'version', class: 'title', align: 'center' },
          { text: 'File #', value: 'ref', class: 'title', align: 'center' },
        ],
        headers_records: [
          { text: 'Crew Name', value: 'nick_name', class: 'title brown lighten-3', width: '40px', sortable: false },
          { text: 'Station', value: 'description', class: 'title brown lighten-3', width: '40px', sortable: false },
          { text: 'BREAK', value: 'break', class: 'title brown lighten-3', width: '12px', sortable: false },
          { text: 'TA', value: 'schedule', class: 'title brown lighten-3', width: '20px', sortable: false },
          { text: 'POSCOD', value: 'position_code', class: 'title brown lighten-3', width: '16px', sortable: false },
          { text: 'HRS', value: 'hours', class: 'title brown lighten-3', width: '8px', sortable: false },
          { text: 'MEAL', value: 'meal', class: 'title brown lighten-3', width: '8px', sortable: false },
          { text: '12', value: '12', class: 'title blue-grey', align: 'center', sortable: false },
          { text: '1', value: '1', class: 'title blue-grey', align: 'center', sortable: false },
          { text: '2', value: '2', class: 'title blue-grey', align: 'center', sortable: false },
          { text: '3', value: '3', class: 'title blue-grey', align: 'center', sortable: false },
          { text: '4', value: '4', class: 'title blue-grey', align: 'center', sortable: false },
          { text: '5', value: '5', class: 'title blue-grey', align: 'center', sortable: false },
          { text: '6', value: '6', class: 'title blue-grey', align: 'center', sortable: false },
          { text: '7', value: '7', class: 'title orange darken-2', align: 'center', sortable: false },
          { text: '8', value: '8', class: 'title orange darken-2', align: 'center', sortable: false },
          { text: '9', value: '9', class: 'title blue-grey', align: 'center', sortable: false },
          { text: '10', value: '10', class: 'title blue-grey', align: 'center', sortable: false },
          { text: '11', value: '11', class: 'title orange darken-2', align: 'center', sortable: false },
          { text: '12', value: '12', class: 'title orange darken-2', align: 'center', sortable: false },
          { text: '1', value: '1', class: 'title orange darken-2', align: 'center', sortable: false },
          { text: '2', value: '2', class: 'title blue-grey', align: 'center', sortable: false },
          { text: '3', value: '3', class: 'title blue-grey', align: 'center', sortable: false },
          { text: '4', value: '4', class: 'title orange darken-2', align: 'center', sortable: false },
          { text: '5', value: '5', class: 'title orange darken-2', align: 'center', sortable: false },
          { text: '6', value: '6', class: 'title orange darken-2', align: 'center', sortable: false },
          { text: '7', value: '7', class: 'title blue-grey', align: 'center', sortable: false },
          { text: '8', value: '8', class: 'title blue-grey', align: 'center', sortable: false },
          { text: '9', value: '9', class: 'title blue-grey', align: 'center', sortable: false },
          { text: '10', value: '10', class: 'title blue-grey', align: 'center', sortable: false },
          { text: '11', value: '11', class: 'title blue-grey', align: 'center', sortable: false },
        ],
        headers_crew_time_availability: [
          { text: 'Crew Name', value: 'name', class: 'title brown lighten-3' },
          { text: '12', value: '12', class: 'title blue-grey', align: 'center' },
          { text: '1', value: '1', class: 'title blue-grey', align: 'center' },
          { text: '2', value: '2', class: 'title blue-grey', align: 'center' },
          { text: '3', value: '3', class: 'title blue-grey', align: 'center' },
          { text: '4', value: '4', class: 'title blue-grey', align: 'center' },
          { text: '5', value: '5', class: 'title blue-grey', align: 'center' },
          { text: '6', value: '6', class: 'title blue-grey', align: 'center' },
          { text: '7', value: '7', class: 'title orange darken-2', align: 'center' },
          { text: '8', value: '8', class: 'title orange darken-2', align: 'center' },
          { text: '9', value: '9', class: 'title blue-grey', align: 'center' },
          { text: '10', value: '10', class: 'title blue-grey', align: 'center' },
          { text: '11', value: '11', class: 'title orange darken-2', align: 'center' },
          { text: '12', value: '12', class: 'title orange darken-2', align: 'center' },
          { text: '1', value: '1', class: 'title orange darken-2', align: 'center' },
          { text: '2', value: '2', class: 'title blue-grey', align: 'center' },
          { text: '3', value: '3', class: 'title blue-grey', align: 'center' },
          { text: '4', value: '4', class: 'title orange darken-2', align: 'center' },
          { text: '5', value: '5', class: 'title orange darken-2', align: 'center' },
          { text: '6', value: '6', class: 'title orange darken-2', align: 'center' },
          { text: '7', value: '7', class: 'title blue-grey', align: 'center' },
          { text: '8', value: '8', class: 'title blue-grey', align: 'center' },
          { text: '9', value: '9', class: 'title blue-grey', align: 'center' },
          { text: '10', value: '10', class: 'title blue-grey', align: 'center' },
          { text: '11', value: '11', class: 'title blue-grey', align: 'center' },
        ],
        headers_available_crew: [
          { text: 'Last Name', value: 'last_name', class: 'title' },
          { text: 'First Name', value: 'first_name', class: 'title' },
          { text: 'Middle Name', value: 'middle_name', class: 'title' },
          { text: 'Nick Name', value: 'nick_name', class: 'title' },
          { text: 'Position', value: 'position_code', class: 'title' },
          { text: 'Time Available', value: 'time_availability', class: 'title' },
          { text: 'Rate', value: 'current_amount', class: 'title' },
          { text: 'Cola', value: 'cola_amount', class: 'title' },
          { text: 'Actions', value: 'actions', class: 'title' },
        ],
        headers_employees: [
          { text: 'Last Name', value: 'last_name', class: 'title' },
          { text: 'First Name', value: 'first_name', class: 'title' },
          { text: 'Middle Name', value: 'middle_name', class: 'title' },
          { text: 'Nick Name', value: 'nick_name', class: 'title' },
          { text: 'Position', value: 'position_code', class: 'title' },
          { text: 'Actions', value: 'actions', class: 'title' },
        ],
        headers_sales: [
          { text: 'Date', value: 'HSPDAY', class: 'title' },
          { text: 'Time', value: 'HSPTIM', class: 'title' },
          { text: 'Gross Sales', value: 'HSPSAG', class: 'title', align: 'right' },
          { text: 'Guest Count', value: 'HSPTAC', class: 'title', align: 'right' },
          { text: 'PRD Sales', value: 'HSPSAG', class: 'title', align: 'right' },
          { text: 'PRD Count', value: 'HSPTAC', class: 'title', align: 'right' },
          { text: 'IR Sales', value: 'HSPSFC', class: 'title', align: 'right' },
          { text: 'IR Guest Count', value: 'HSPTFC', class: 'title', align: 'right' },
          { text: 'DT Sales', value: 'HSPSDT', class: 'title', align: 'right' },
          { text: 'DT Guest Count', value: 'HSPTDT', class: 'title', align: 'right' },
          { text: 'MDS Sales', value: 'HSPSDS', class: 'title', align: 'right' },
          { text: 'MDS Guest Count', value: 'HSPTDS', class: 'title', align: 'right' },
          { text: 'McCAFE Sales', value: 'HSPSCF', class: 'title', align: 'right' },
          { text: 'McCAFE Guest Count', value: 'HSPTCF', class: 'title', align: 'right' },
          { text: 'DC Sales', value: 'HSPSCO', class: 'title', align: 'right' },
          { text: 'DC Guest Count', value: 'HSPTCO', class: 'title', align: 'right' },
        ],
        headers_jobrotation: [
          { text: 'Crew Name', value: 'crew_name', class: 'title' },
          { text: 'MON', value: 'MON_r', class: 'title' },
          { text: 'TUE', value: 'TUE_r', class: 'title' },
          { text: 'WED', value: 'WED_r', class: 'title' },
          { text: 'THU', value: 'THU_r', class: 'title' },
          { text: 'FRI', value: 'FRI_r', class: 'title' },
          { text: 'SAT', value: 'SAT_r', class: 'title' },
          { text: 'SUN', value: 'SUN_r', class: 'title' },
          { text: 'MON', value: 'MON', class: 'title' },
          { text: 'TUE', value: 'TUE', class: 'title' },
          { text: 'WED', value: 'WED', class: 'title' },
          { text: 'THU', value: 'THU', class: 'title' },
          { text: 'FRI', value: 'FRI', class: 'title' },
          { text: 'SAT', value: 'SAT', class: 'title' },
          { text: 'SUN', value: 'SUN', class: 'title' },
        ],
        headers_without_schedule: [
          { text: 'Crew Name', value: 'crew_name', class: 'title' },
        ],
        headers_advance_plot: [
          { text: 'TRAINED AREA', value: 'trained_area', class: 'title teal' },
          { text: '12', value: '0', class: 'title blue-grey' },
          { text: '1', value: '1', class: 'title blue-grey' },
          { text: '2', value: '2', class: 'title blue-grey' },
          { text: '3', value: '3', class: 'title blue-grey' },
          { text: '4', value: '4', class: 'title blue-grey' },
          { text: '5', value: '5', class: 'title blue-grey' },
          { text: '6', value: '6', class: 'title blue-grey' },
          { text: '7', value: '7', class: 'title orange darken-2' },
          { text: '8', value: '8', class: 'title orange darken-2' },
          { text: '9', value: '9', class: 'title blue-grey' },
          { text: '10', value: '10', class: 'title blue-grey' },
          { text: '11', value: '11', class: 'title orange darken-2' },
          { text: '12', value: '12', class: 'title orange darken-2' },
          { text: '1', value: '13', class: 'title orange darken-2' },
          { text: '2', value: '14', class: 'title blue-grey' },
          { text: '3', value: '15', class: 'title blue-grey' },
          { text: '4', value: '16', class: 'title orange darken-2' },
          { text: '5', value: '17', class: 'title orange darken-2' },
          { text: '6', value: '18', class: 'title orange darken-2' },
          { text: '7', value: '19', class: 'title blue-grey' },
          { text: '8', value: '20', class: 'title blue-grey' },
          { text: '9', value: '21', class: 'title blue-grey' },
          { text: '10', value: '22', class: 'title blue-grey' },
          { text: '11', value: '23', class: 'title blue-grey' },
        ],
        headers_summary: [],
        headers_summary2: [],
        without_schedule: [],
        show_document: false,
        show_crew: false,
        show_generate_projection: false,
        show_sales: false,
        show_jobrotation: false,
        show_crew_time_availability: false,
        loading_document: true,
        loading_document_history: true,
        loading_records: true,
        loading_available_crew: true,
        loading_stations: true,
        loading_crew_time_availability: false,
        loading_jobrotation: true,
        loading_employees: true,
        loading_summary: true,
        skip_summary: true,
        skip_document: true,
        skip_document_history: true,
        skip_records: true,
        skip_available_crew: true,
        skip_crew_time_availability: true,
        skip_jobrotation: true,
        skip_employees: true,
        crew_title: '',
        date_menu: false,
        date_menu_from: false,
        date_menu_to: false,
        starting_date: moment().format('YYYY-MM-DD'),
        date_from: moment().format('YYYY-MM-DD'),
        date_to: moment().format('YYYY-MM-DD'),
        sales_date: '',
        sales_count: 0,
        gross_sales: 0.0,
        drawer: null,
        data_color: 'red lighten-2',
        input_color: 'green darken-3',
        entry_color: 'amber',
        separator_color: 'brown lighten-3',
        default_plot: [['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']],
        user_inputs: [],
        input: [],
        input_title: '',
        input_item: '',
        day_part_reg: 'REG',
        totals: {},
        jobrotation: [],
        hours_summary: 0.0,
        fixed_hours: 0.0,
        labor: 0.0,
        night_diff: 0.0,
        expense: 0.0,
        meal_a: 0,
        meal_a_value: 22.85,
        meal_b: 0,
        meal_b_value: 22.75,
        slider: [0, 24],
        show_manager: false,
        show_adjust: false,
        updating: false,
        edited_index: 0,
        edited_name: '',
        edited_item: {
          uid: '',
        },
        edited_items: null,
        sliders: null,
        updating_jobrotation: false,
        updating_break: false,
        updating_expense: false,
        updating_schedule: false,
        description: '',
        nick_name: '',
        time_availability: '',
        is_schedule_valid: false,
        posted: false,
        locked: false,
        is_changed: false,
        output: null,
        advance_plot_input: [],
        show_advance_plot: false,
        max_hours: 0,
        min_plot: 0,
        max_plot: 0,
        isplot_valid: false,
        advance_plot_parse: [],
        document_uid: '',
        documents_hash: '',
        employees_hash: '',
        crew_hash: '',
        records_hash: '',
        record_uid: '',
        total: 0,
        options: {
          page: 1,
          itemsPerPage: 10,
        },
        options_summary: {
          page: 1,
          itemsPerPage: 10,
        },
        cross_schedule: false,
        disable_cross_schedule: false,
        show_export: false,
        filename: '',
        personnelidno: '',
        generating: false,
        show_version_history: false,
        selected_item: 0,
        selected_uid: '',
        reference_number: 0,
        version_list: [],
        stations: [],
        stations_b: [],
        station_hash: '',
        station_hash_b: '',
        select_station: null,
        crew_filtered: [],
      }
    },
    computed: {
      ...mapState(['in_process', 'default_error', 'access', 'roles']),
    },
    watch: {
      options: {
        handler () {
          this.GetDocuments()
        },
        deep: true,
      },
      options_summary: {
        handler () {
          this.$forceUpdate()
        },
        deep: true,
      },
      cross_schedule: {
        handler () {
          this.SetSlider()
        },
        deep: true,
      },
      select_station: {
        handler () {
          this.FilterCrew()
        },
        deep: true,
      },
    },
    mounted () {
      window.scrollTo(0, 0)
      this.GetDocuments()
      this.GetScheduleSummary()
    },
    methods: {
      FilterCrew () {
        if (this.select_station && this.select_station !== 'null' && this.select_station !== 'undefined') {
          if (!this.show_manager) {
            if (this.select_station.length === 0) {
              this.crew_filtered = this.available_crew
            } else {
              var filter = this.select_station
              if (filter.length === 2) {
                this.crew_filtered = this.available_crew.filter(function (i) {
                  return (
                    i.trained_areas.includes(filter[0]) && i.trained_areas.includes(filter[1])
                  )
                })
              } else {
                this.crew_filtered = this.available_crew.filter(function (i) {
                  return (
                    i.trained_areas.includes(filter[0])
                  )
                })
              }
            }
          }
          if (this.select_station.length >= 2) {
            for (const index in this.stations) {
              if (!this.select_station.includes(this.stations[index].key_code)) { this.stations[index].disabled = true }
            }
          } else {
            for (const index in this.stations) {
              this.stations[index].disabled = false
            }
          }
        }
      },
      BytesToSize (bytes) {
        var sizes = ['B', 'KB', 'MB', 'GB', 'TB']
        if (bytes === 0) return '0 B'
        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
        return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
      },
      Print () {
        if (!this.access.includes(this.roles.scheduler_print)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        var print = document.getElementById('schedule')
        var w = window.open(' ', 'print', 'toolbar=yes,scrollbars=yes,resizable=yes,height=' + screen.height + ',width=' + screen.width)
        w.document.write('<html><head><link rel="icon" href="/favicon.png"><title>Print Schedule</title>' +
          '<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900">' +
          '<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css">' +
          '<link rel="stylesheet" href="https://escheduling.mcd.com.ph/print.css" type="text/css" />' +
          '</head><body><div id="printdiv" class="v-application"></div></body></html>')
        w.document.getElementById('printdiv').innerHTML = print.outerHTML
        setTimeout(() => { w.print() }, 800)
      },
      PrintTA () {
        var print = document.getElementById('crewTA')
        var w = window.open(' ', 'print', 'toolbar=yes,scrollbars=yes,resizable=yes,height=' + screen.height + ',width=' + screen.width)
        w.document.write('<html><head><link rel="icon" href="/favicon.png"><title>Print Crew Time Availability</title>' +
          '<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900">' +
          '<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css">' +
          '<link rel="stylesheet" href="https://escheduling.mcd.com.ph/print.css" type="text/css" /></head><body></body></html>')
        w.document.body.innerHTML = print.outerHTML
        w.document.getElementById('printmenu').innerHTML = ''
        setTimeout(() => { w.print() }, 800)
      },
      PrintHoursWorked () {
        var print = document.getElementById('hoursworked')
        var w = window.open(' ', 'print', 'toolbar=yes,scrollbars=yes,resizable=yes,height=' + screen.height + ',width=' + screen.width)
        w.document.write('<html><head><link rel="icon" href="/favicon.png"><title>Print Job Rotation & Hours Worked</title>' +
          '<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900">' +
          '<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css">' +
          '<link rel="stylesheet" href="https://escheduling.mcd.com.ph/print.css" type="text/css" /></head><body></body></html>')
        w.document.body.innerHTML = print.outerHTML
        w.document.getElementById('printmenu').innerHTML = ''
        setTimeout(() => { w.print() }, 800)
      },
      PrintHourlySales () {
        var print = document.getElementById('hourlysales')
        var w = window.open(' ', 'print', 'toolbar=yes,scrollbars=yes,resizable=yes,height=' + screen.height + ',width=' + screen.width)
        w.document.write('<html><head><link rel="icon" href="/favicon.png"><title>Print Hourly Sales</title>' +
          '<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900">' +
          '<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css">' +
          '<link rel="stylesheet" href="https://escheduling.mcd.com.ph/print.css" type="text/css" /></head><body></body></html>')
        w.document.body.innerHTML = print.outerHTML
        w.document.getElementById('printmenu').innerHTML = ''
        setTimeout(() => { w.print() }, 800)
      },
      GetIconMultiple (item) {
        var r = this.records.filter(function (record) {
          return (
            record.personnelidno === item.personnelidno && record.week_day_id === record.wid
          )
        })
        if (r.length > 1) {
          for (const index in r) {
            if (r[index].uid === item.uid) { return 'mdi mdi-numeric-' + (Number(index) + 1) + '-circle-outline' }
          }
        } else {
          return ''
        }
      },
      UpdateSummary () {
        for (const index in this.business_extensions) {
          this.CreateTotals(this.business_extensions[index].name)
        }
        this.ComputeLabor()
      },
      IsScheduleValid () {
        if (!this.show_adjust) { return }
        var item = this.edited_item
        var prev = this.records.filter(function (record) { // check previous schedules
          return (
            record.personnelidno === item.personnelidno && record.week_day_id !== record.wid
          )
        })
        //
        var s = this.edited_item.time_availability.split('-')
        var h = 0.0
        var min = 0.0
        var max = 0.0
        var t = 0.0
        var min1 = 0.0
        var max1 = 0.0
        var p = 0.0
        var ps = null
        var n = 0
        //
        h = this.GetTimeSpan(s[0], s[1])
        min = this.GetTimeToInt(s[0], s[0])
        max = this.GetTimeToInt(s[1], s[0])
        if (max < min && max === 0) { max = 24 }
        if (this.edited_items) { // multiple schedule
          // validate  if plotting is out of time availability
          for (const index in this.sliders) {
            if (this.sliders[index][0] === 0 && this.sliders[index][1] === 0) { continue }
            if (this.sliders[index][0] === this.sliders[index][1]) { continue }
            if (this.sliders[index][0] < min || this.sliders[index][0] > max) {
              this.is_schedule_valid = false; return this.is_schedule_valid
            } else if (this.sliders[index][1] < min || this.sliders[index][1] > max) {
              this.is_schedule_valid = false; return this.is_schedule_valid
            }
          }

          // validate if plotting is less than total TA
          var min2 = this.sliders[0][0]
          var max2 = this.sliders[0][1]
          for (const index in this.sliders) {
            if (this.sliders[index][0] === 0 && this.sliders[index][1] === 0) { continue }
            if (this.sliders[index][0] === this.sliders[index][1]) { continue }
            if (min2 > this.sliders[index][0]) { min2 = this.sliders[index][0] }
            if (max2 < this.sliders[index][1]) { max2 = this.sliders[index][1] }
          }
          if ((max2 - min2) < 4 || (max2 - min2) > h) { this.is_schedule_valid = false; return this.is_schedule_valid }
          min = min2
          max = max2
          // validate for overlapping schedule
          for (n = 0; n < 24; ++n) {
            t = 0.0
            for (const index in this.sliders) {
              min1 = this.sliders[index][0]
              max1 = this.sliders[index][1]
              if (max1 < min1 && max1 === 0) { max1 = 24 }
              p = (n >= min1 && n <= max1) ? 1 : 0
              if ((n + 0.5) === min1) { p = 0.5 }
              if ((n + 0.5) === max1) { p = 0.5 }
              if ((n) === max1) { p = 0 }
              t = t + p
            }
            for (const index in prev) { // elapse from previous schedule
              ps = prev[index].schedule.split('-')
              min1 = 0
              max1 = this.GetTimeToInt(ps[1], '00:00')
              p = (n >= min1 && n <= max1) ? 1 : 0
              if ((n + 0.5) === min1) { p = 0.5 }
              if ((n + 0.5) === max1) { p = 0.5 }
              if ((n) === max1) { p = 0 }
              t = t + p
            }
            if (t > 1) {
              this.is_schedule_valid = false; return this.is_schedule_valid
            } else if (t < 1) {
              if ((n + 0.5) === min || (n + 0.5) === max) {
                if (t === 0) { this.is_schedule_valid = false; return this.is_schedule_valid }
              } else if (n === max) {
                if (t > 0) { this.is_schedule_valid = false; return this.is_schedule_valid }
              } else if (n >= min && n <= max) {
                this.is_schedule_valid = false; return this.is_schedule_valid
              }
            }
          }
          // validate if total hours match to selected time availability
          t = 0.0
          for (const index in this.sliders) {
            t = t + (this.sliders[index][1] - this.sliders[index][0])
          }
          if (t >= 4 && t <= h) { this.is_schedule_valid = true; return this.is_schedule_valid }
        } else {
          // manager schedule validation;
          // obsolete: crew w/ single schedule not editable
          // new update: allow edit all including single entry
          if (!this.edited_item.personnelidno) { this.is_schedule_valid = false; return this.is_schedule_valid }

          // validate if beyond 4-7 hours
          t = this.slider[1] - this.slider[0]
          if (t < 4) { this.is_schedule_valid = false; return this.is_schedule_valid }

          if (this.edited_item.trained_area_id === 1) { // if manager
            if (t > 8) { this.is_schedule_valid = false; return this.is_schedule_valid } // requires 8-hours shiftmaster schedule
          } else {
            if (t > 7) { this.is_schedule_valid = false; return this.is_schedule_valid }
          }
          // validate for overlapping schedule
          // if (prev.length > 0) {
          //   for (n = 0; n < 24; ++n) {
          //     t = 0.0
          //     min1 = this.slider[0]
          //     max1 = this.slider[1]
          //     if (max1 < min1 && max1 === 0) { max1 = 24 }
          //     p = (n >= min1 && n <= max1) ? 1 : 0
          //     if ((n + 0.5) === min1) { p = 0.5 }
          //     if ((n + 0.5) === max1) { p = 0.5 }
          //     if ((n) === max1) { p = 0 }
          //     t = t + p
          //     for (const index in prev) { // elapse from previous schedule
          //       ps = prev[index].schedule.split('-')
          //       min1 = 0
          //       max1 = this.GetTimeToInt(ps[1], '00:00')
          //       // console.log(max1)
          //       p = (n >= min1 && n <= max1) ? 1 : 0
          //       if ((n + 0.5) === min1) { p = 0.5 }
          //       if ((n + 0.5) === max1) { p = 0.5 }
          //       if ((n) === max1) { p = 0 }
          //       t = t + p
          //     }
          //     if (t > 1) {
          //       this.is_schedule_valid = false; return this.is_schedule_valid
          //     } else if (t < 1) {
          //       if ((n + 0.5) === min || (n + 0.5) === max) {
          //         if (t === 0) { this.is_schedule_valid = false; return this.is_schedule_valid }
          //       } else if (n === max) {
          //         if (t > 0) { this.is_schedule_valid = false; return this.is_schedule_valid }
          //       } else if (n >= min && n <= max) {
          //         this.is_schedule_valid = false; return this.is_schedule_valid
          //       }
          //     }
          //   }
          // }
          //
          if (this.edited_item.trained_area_id === 1) { this.is_schedule_valid = true; return this.is_schedule_valid } // if manager

          // validate if hours exceed TA
          if (t > h) { this.is_schedule_valid = false; return this.is_schedule_valid }

          // validate  if schedule is out of time availability
          if (this.slider[0] < min || this.slider[0] > max) {
            this.is_schedule_valid = false; return this.is_schedule_valid
          } else if (this.slider[1] < min || this.slider[1] > max) {
            this.is_schedule_valid = false; return this.is_schedule_valid
          }
          this.is_schedule_valid = true; return this.is_schedule_valid
        }
        this.is_schedule_valid = false; return this.is_schedule_valid
      },
      GetStationFilterColor () {
        if (this.select_station && this.select_station !== 'null' && this.select_station !== 'undefined') {
          return this.select_station.length === 0 ? '' : 'primary'
        } else {
          return ''
        }
      },
      GetSliderTrackColor () {
        return this.is_schedule_valid ? 'primary' : 'orange darken-2'
      },
      GetEditScheduleColor (item) {
        return this.IsScheduleEditable(item) ? 'primary' : 'black'
      },
      GetTimeSpanTA (t) {
        var s = t.split('-')
        return this.GetTimeSpan(s[0], s[1])
      },
      IsScheduleEditable (item) {
        // obsolete :
        return true // allow edit all including single entry
      },
      IsSelectable (item) {
        var r = this.records.filter(function (record) {
          return (
            record.personnelidno === item.personnelidno
          )
        })
        if (r.length === 0) { return true }
        if (r.length >= 1 && r.length <= 2) {
          for (const index in r) {
            if (r[index].trained_area_id === this.trained_area_id && r[index].week_day_id === r[index].wid) { return false }
          }
          return true
        } else {
          return false
        }
      },
      ArchiveDocument (uid) {
        if (!this.access.includes(this.roles.scheduler_manage)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.$refs.confirm.open('Please Confirm!', 'You are going to archive this data!', { color: 'red' })
          .then((confirm) => {
            if (confirm) {
              this.$store.commit('Notify', 'Archiving data...')
              this.$apollo.mutate({
                mutation: ArchiveDocument,
                variables: {
                  uid: uid,
                  hash: this.documents_hash,
                },
              }).then((res) => {
                if (res.data.ArchiveDocument.status === 'Ok') {
                  this.$store.commit('CloseAlert', 'Data has been archived!')
                  this.GetDocuments()
                } else if (res.data.ArchiveDocument.status === '0') {
                  this.CheckError({ message: 'Session expired!' })
                } else {
                  this.$store.commit('ShowError', res.data.ArchiveDocument.status)
                }
              }).catch(error => {
                this.CheckError(error)
              })
            }
          })
      },
      PostDocument (uid) {
        if (!this.access.includes(this.roles.scheduler_manage)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.$refs.confirm.open('Please Confirm!', 'You are going to post this data!', { color: 'red' })
          .then((confirm) => {
            if (confirm) {
              this.$store.commit('Notify', 'Posting data...')
              this.$apollo.mutate({
                mutation: PostDocument,
                variables: {
                  uid: uid,
                  hash: this.documents_hash,
                },
              }).then((res) => {
                if (res.data.PostDocument.status === 'Ok') {
                  this.$store.commit('CloseAlert', '')
                  this.GetDocuments()
                } else if (res.data.PostDocument.status === '0') {
                  this.CheckError({ message: 'Session expired!' })
                } else {
                  this.$store.commit('ShowError', res.data.PostDocument.status)
                }
              }).catch(error => {
                this.CheckError(error)
              })
            }
          })
      },
      UnpostDocument (uid) {
        if (!this.access.includes(this.roles.scheduler_manage)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.$refs.confirm.open('Please Confirm!', 'You are going to unpost this data!', { color: 'red' })
          .then((confirm) => {
            if (confirm) {
              this.$store.commit('Notify', 'Unposting data...')
              this.$apollo.mutate({
                mutation: UnpostDocument,
                variables: {
                  uid: uid,
                  hash: this.documents_hash,
                },
              }).then((res) => {
                if (res.data.UnpostDocument.status === 'Ok') {
                  this.$store.commit('CloseAlert', '')
                  this.GetDocuments()
                } else if (res.data.UnpostDocument.status === '0') {
                  this.CheckError({ message: 'Session expired!' })
                } else {
                  this.$store.commit('ShowError', res.data.UnpostDocument.status)
                }
              }).catch(error => {
                this.CheckError(error)
              })
            }
          })
      },
      GetDay () {
        return moment(this.sales[0].HSPDAY).subtract(1, 'days').format('ddd')
      },
      GetDateFormat (d) {
        if (!d) { return '' }
        return moment(d).format('YYYY-MM-DD hh:mm A')
      },
      GetLongDateFormat (d) {
        if (!d) { return '' }
        return moment(d).format('LLL')
      },
      GetDateRange () {
        return moment(this.starting_date).format('MMM DD') + ' to ' + moment(this.starting_date).add(6, 'days').format('DD, YYYY')
      },
      UpdateBreak () {
        if (this.posted) { return }
        if (!this.access.includes(this.roles.scheduler_manage)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        if (this.edited_item.break.length < 3) {
          this.$store.commit('ShowError', 'Invalid input!')
          return
        }
        if (!moment(this.edited_item.break, 'LT').isValid()) {
          this.$store.commit('ShowError', 'Invalid input!')
          return
        }
        this.updating_break = true
        this.$apollo.mutate({
          mutation: UpdateBreak,
          variables: {
            uid: this.edited_item.uid,
            hash: this.records_hash,
            break: this.edited_item.break,
          },
        }).then((res) => {
          if (res.data.UpdateBreak.status === 'Ok') {
          } else if (res.data.UpdateBreak.status === '0') {
            this.CheckError({ message: 'Session expired!' })
          } else {
            this.$store.commit('ShowError', res.data.UpdateBreak.status)
          }
          this.updating_break = false
        }).catch(error => {
          this.updating_break = (!error)
          this.CheckError(error)
        })
      },
      SetSlider () {
        if (this.edited_item.uid === '') { return }
        if (this.edited_item.trained_area_id === 1) { // if manager
          var s = this.edited_item.schedule.split('-')
          var min = this.GetTimeToInt(s[0], s[0])
          var max = this.GetTimeToInt(s[1], s[0])
          if (this.cross_schedule) {
            if (min < 18) { this.slider = [18, 18] }
          } else {
            if (max > 24) { this.slider = [0, 0] }
          }
        }
      },
      EditSchedule (item) {
        if (this.posted) { return }
        if (!this.access.includes(this.roles.scheduler_manage)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.edited_items = null
        this.sliders = null
        this.edited_item = item
        this.trained_area = item.trained_area
        this.nick_name = item.nick_name
        this.time_availability = item.time_availability
        this.description = item.description
        var r = this.records.filter(function (record) {
          return (
            record.personnelidno === item.personnelidno && record.week_day_id === record.wid
          )
        })
        if (item.schedule === '') { // advance plotting
          if (item.advance_plot === '' || item.advance_plot === null) { return }
          this.edited_items = r
          this.ShowAdvancePlot()
        } else { // time range plotting
          var s = item.schedule.split('-')
          var min = this.GetTimeToInt(s[0], s[0])
          var max = this.GetTimeToInt(s[1], s[0])
          if (max < min && max === 0) { max = 24 }
          this.slider = [min, max]
          // console.log('min:' + min + ' max:' + max)
          var t = item.time_availability.split('-')
          var max2 = this.GetTimeToInt(t[1], t[0])
          this.cross_schedule = (max2 > 24)
          // enable cross schedule for managers
          this.disable_cross_schedule = (item.trained_area_id !== 1)
          if (r.length > 1) {
            // populate ui edit
            this.edited_items = r
            this.sliders = []
            var c = 0
            for (const index in r) {
              s = r[index].schedule.split('-')
              min = this.GetTimeToInt(s[0], s[0])
              max = this.GetTimeToInt(s[1], s[0])
              if (max < min && max === 0) { max = 24 }
              if (r[index].week_day_id === r[index].wid) {
                this.sliders.push([min, max])
                c += 1
              }
            }
            if (c > 1) this.description = 'Multiple Segment'
          }
          this.show_adjust = true
        }
      },
      ValidateSchedule () {
        if (this.posted) { return }
        if (this.edited_items) { // multiple schedule
          this.UpdateScheduleMultiple()
        } else {
          this.UpdateSchedule()
        }
      },
      UpdateSchedule () { // for single schedule
        this.$store.commit('Notify', '')
        var isManager = (this.edited_item.trained_area_id === 1)
        var h = this.slider[1] - this.slider[0]
        var sched = this.GetIntToTime(this.slider[0]) + '-' + this.GetIntToTime(this.slider[1])
        var meal = isManager ? '-' : ((h > 4) ? 'B' : 'A')
        this.$apollo.mutate({
          mutation: UpdateSchedule,
          variables: {
            uid: this.edited_item.uid,
            hash: this.records_hash,
            schedule: sched,
          },
        }).then((res) => {
          if (res.data.UpdateSchedule.status === 'Ok') {
            this.edited_item.schedule = sched
            this.edited_item.hours = h
            this.edited_item.meal = meal
            if (res.data.UpdateSchedule.TA !== '') { this.edited_item.time_availability = res.data.UpdateSchedule.TA }
            this.meal_a = res.data.UpdateSchedule.meal[0].meal_a
            this.meal_b = res.data.UpdateSchedule.meal[0].meal_b
            this.$store.commit('CloseAlert', '')
            this.show_adjust = false
            this.UpdateSummary()
          } else if (res.data.UpdateSchedule.status === '0') {
            this.CheckError({ message: 'Session expired!' })
          } else {
            this.$store.commit('ShowError', res.data.UpdateSchedule.status)
          }
        }).catch(error => {
          this.CheckError(error)
        })
      },
      UpdateScheduleMultiple () { // for multiple segment schedule
        var data = []
        for (const index in this.edited_items) {
          data.push({
            uid: this.edited_items[index].uid,
            schedule: this.GetIntToTime(this.sliders[index][0]) + '-' + this.GetIntToTime(this.sliders[index][1]),
          })
        }
        this.$store.commit('Notify', '')
        this.$apollo.mutate({
          mutation: UpdateScheduleMultiple,
          variables: {
            hash: this.records_hash,
            data: JSON.stringify(data),
          },
        }).then((res) => {
          if (res.data.UpdateScheduleMultiple.status === 'Ok') {
            // update ui data
            for (const index in this.edited_items) {
              this.edited_items[index].schedule = this.GetIntToTime(this.sliders[index][0]) + '-' + this.GetIntToTime(this.sliders[index][1])
              this.edited_items[index].hours = this.sliders[index][1] - this.sliders[index][0]
              if (this.edited_items[index].meal !== '-') { this.edited_items[index].meal = res.data.UpdateScheduleMultiple.meal_update }
            }
            this.meal_a = res.data.UpdateScheduleMultiple.meal[0].meal_a
            this.meal_b = res.data.UpdateScheduleMultiple.meal[0].meal_b
            this.$store.commit('CloseAlert', '')
            this.show_adjust = false
            this.UpdateSummary()
          } else if (res.data.UpdateScheduleMultiple.status === '0') {
            this.CheckError({ message: 'Session expired!' })
          } else {
            this.$store.commit('ShowError', res.data.UpdateScheduleMultiple.status)
          }
        }).catch(error => {
          this.CheckError(error)
        })
      },
      UpdateExpense () {
        if (this.posted) { return }
        this.updating_expense = true
        this.user_inputs.expense = this.expense
        this.$apollo.mutate({
          mutation: UpdateUserInput,
          variables: {
            input: {
              uid: this.document_uid,
              hash: this.documents_hash,
              week_day_id: this.week_day_id,
              user_input: JSON.stringify(this.user_inputs),
            },
          },
        }).then((res) => {
          if (res.data) {
            this.updating_expense = false
          }
        }).catch(error => {
          this.updating_expense = (!error)
          this.CheckError(error)
        })
      },
      SaveInput () {
        this.updating = true
        this.$apollo.mutate({
          mutation: UpdateUserInput,
          variables: {
            input: {
              uid: this.document_uid,
              hash: this.documents_hash,
              week_day_id: this.week_day_id,
              user_input: JSON.stringify(this.user_inputs),
            },
          },
        }).then((res) => {
          if (res.data) {
            this.updating = false
            this.is_changed = false
            // this.$store.commit('CloseAlert', '')
          }
        }).catch(error => {
          this.updating = false
          this.CheckError(error)
        })
      },
      CloseDocument () {
        this.show_document = false
        document.documentElement.style.overflow = 'visible'
      },
      GetJobRotation () {
        this.loading_jobrotation = true
        this.jobrotation = []
        this.without_schedule = []
        this.skip_jobrotation = false
        this.show_jobrotation = true
        this.$apollo.queries.GetJobRotation.refetch()
      },
      CrewTimeAvailability () {
        this.totals.TA = []
        this.crew_time_availability = []
        this.loading_crew_time_availability = true
        this.skip_crew_time_availability = false
        this.show_crew_time_availability = true
        this.$apollo.queries.CrewTimeAvailability.refetch()
      },
      GetDocuments () {
        this.loading_document = true
        this.documents = []
        this.skip_document = false
        this.$apollo.queries.Documents.refetch()
      },
      GetScheduleSummary () {
        this.summary = []
        this.headers_summary = []
        this.loading_summary = true
        this.skip_summary = false
        this.$apollo.queries.GetScheduleSummary.refetch()
      },
      GetManagers () {
        this.loading_employees = true
        this.loading_stations = true
        this.employees = []
        this.skip_employees = false
        this.$apollo.queries.GetManagers.refetch()
      },
      GetRecords (uid = this.document_uid, id2 = this.sched_tab) {
        this.hours_summary = 0.0
        this.fixed_hours = 0.0
        this.labor = 0.0
        this.night_diff = 0.0
        this.sched_tab = id2
        this.show_document = true
        this.skip_records = false
        this.loading_records = true
        this.records = []
        this.sales = []
        this.document_uid = uid
        this.week_day_id = this.week_day_values[id2]
        this.advance_plot_parse = []
        this.posted = false
        this.$apollo.queries.DocumentRecords.refetch()
        document.documentElement.style.overflow = 'hidden'
      },
      ShowCrew (item) {
        if (!this.access.includes(this.roles.scheduler_manage)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        if (this.$refs.crew_schedule) { this.$refs.crew_schedule.resetValidation() }
        this.crew_title = 'Available ' + item.description
        this.trained_area = item.trained_area
        this.show_manager = (item.trained_area_id === 1)
        if (!this.show_manager) {
          this.skip_available_crew = false
          this.loading_available_crew = true
          this.loading_stations = true
          this.available_crew = []
          this.crew_filtered = []
          if (this.trained_area_id === item.trained_area_id) {
            this.$apollo.queries.AvailableCrew.refetch()
          }
        } else {
          this.stations = JSON.parse(JSON.stringify(this.stations_b))
          this.station_hash = this.station_hash_b
        }
        this.trained_area_id = item.trained_area_id
        this.record_uid = item.uid
        this.select_station = null
        this.show_crew = true
      },
      CreateRecord (item, hash) {
        if (this.posted) { return }
        if (!this.$refs.crew_schedule.validate()) {
          this.$store.commit('ShowError', 'Please select station!')
          return
        }
        if (this.select_station.length === 0) {
          this.$store.commit('ShowError', 'Please select station!')
          return
        }
        this.$store.commit('Notify', 'Creating record...')
        var sta = []
        for (const index in this.stations) {
          if (this.select_station.includes(this.stations[index].key_code)) { sta.push(this.stations[index].uid) }
        }
        this.$apollo.mutate({
          mutation: CreateRecord,
          variables: {
            input: {
              uid: item.uid,
              hash: hash,
              doc_uid: this.document_uid,
              doc_hash: this.documents_hash,
              record_uid: this.record_uid,
              record_hash: this.records_hash,
              station_hash: this.station_hash,
              stations: JSON.stringify(sta),
            },
          },
        }).then((res) => {
          if (res.data.CreateRecord.status === 'Ok') {
            var i = 0
            for (const index in this.records) {
              if (this.records[index].trained_area_id === this.trained_area_id) {
                i = index
              }
            }
            res.data.CreateRecord.data[0].start = res.data.CreateRecord.data[0].schedule !== '' ? res.data.CreateRecord.data[0].schedule.split('-')[0] : ''
            res.data.CreateRecord.data[0].end = res.data.CreateRecord.data[0].schedule !== '' ? res.data.CreateRecord.data[0].schedule.split('-')[1] : ''
            this.records.splice(i, 0, res.data.CreateRecord.data[0])
            this.meal_a = 0
            this.meal_b = 0
            if (res.data.CreateRecord.meal) {
              if (res.data.CreateRecord.meal[0].meal_a) {
                this.meal_a = res.data.CreateRecord.meal[0].meal_a
              }
              if (res.data.CreateRecord.meal[0].meal_b) {
                this.meal_b = res.data.CreateRecord.meal[0].meal_b
              }
            }
            this.$store.commit('CloseAlert', '')
            this.UpdateSummary()
            this.$refs.crew_schedule.resetValidation()
          } else if (res.data.CreateRecord.status === '0') {
            this.CheckError({ message: 'Session expired!' })
          } else {
            this.$store.commit('ShowError', res.data.CreateRecord.status)
          }
        }).catch(error => {
          this.CheckError(error)
        })
      },
      DeleteRecord (item) {
        if (this.posted) { return }
        if (!this.access.includes(this.roles.scheduler_manage)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        var r = null
        var multiple = false
        var confirm = 'You are going to delete this record!'
        if (item.trained_area_id !== 1) {
          if (item.meal === '-') {
            if (item.hours > 0) {
              this.$store.commit('ShowError', 'You need to reset this record before deleting!')
              return
            }
          } else {
            r = this.records.filter(function (record) {
              return (
                record.personnelidno === item.personnelidno
              )
            })
            if (r.length > 1) {
              multiple = true
              confirm = 'Deleting primary record will also deletes multiple schedules for this crew on the same day!'
            }
          }
        }
        this.$refs.confirm.open('Please Confirm!', confirm, { color: 'red' })
          .then((confirm) => {
            if (confirm) {
              this.$store.commit('Notify', 'Deleting record...')
              this.$apollo.mutate({
                mutation: DeleteRecord,
                variables: {
                  uid: item.uid,
                  hash: this.records_hash,
                },
              }).then((res) => {
                if (res.data.DeleteRecord.status === 'Ok') {
                  if (multiple === true) {
                    var d = Object.assign([], r)
                    for (const i in d) {
                      r = this.records.filter(function (record) {
                        return (
                          record.uid === d[i].uid
                        )
                      })
                      this.records.splice(this.records.indexOf(r[0]), 1)
                    }
                  } else {
                    this.records.splice(this.records.indexOf(item), 1)
                  }
                  this.meal_a = 0
                  this.meal_b = 0
                  if (res.data.DeleteRecord.meal) {
                    if (res.data.DeleteRecord.meal[0].meal_a) {
                      this.meal_a = res.data.DeleteRecord.meal[0].meal_a
                    }
                    if (res.data.DeleteRecord.meal[0].meal_b) {
                      this.meal_b = res.data.DeleteRecord.meal[0].meal_b
                    }
                  }
                  this.$store.commit('CloseAlert', 'Record has been deleted!')
                  this.UpdateSummary()
                } else if (res.data.DeleteRecord.status === '0') {
                  this.CheckError({ message: 'Session expired!' })
                } else {
                  this.$store.commit('ShowError', res.data.DeleteRecord.status)
                }
              }).catch(error => {
                this.CheckError(error)
              })
            }
          })
      },
      GetChannelDescription (extension) {
        var ext = this.business_extensions.filter(function (item) {
          return (item.name === extension)
        })
        if (Object.entries(ext).length === 0) { return '' }
        return ext[0].description
      },
      ShowSales (extension) {
        var ext = this.business_extensions.filter(function (item) {
          return (item.name === extension)
        })
        if (Object.entries(ext).length === 0) { return false }
        return ext[0].sales_field !== ''
      },
      GetSalesCount (index, extension) {
        var ext = this.business_extensions.filter(function (item) {
          return (item.name === extension)
        })
        if (Object.entries(ext).length === 0) { return 0 }
        if (ext == null) { return 0 }
        var sales = this.sales[index][ext[0].sales_count_field]
        return sales > 0 ? sales : 0
      },
      GetGuestCount (extension) {
        var ext = this.business_extensions.filter(function (item) {
          return (item.name === extension)
        })
        if (Object.entries(ext).length === 0) { return 0 }
        return this.sales.reduce((sum, item) => {
          return sum + item[ext[0].sales_count_field]
        }, 0)
      },
      GetSales (extension) {
        var ext = this.business_extensions.filter(function (item) {
          return (item.name === extension)
        })
        if (Object.entries(ext).length === 0) { return 0 }
        if (ext == null) { return 0 }
        var sales = this.sales.reduce((sum, item) => {
          return sum + item[ext[0].sales_field]
        }, 0)
        return sales
      },
      GetVariableHours (index, extension) {
        var count = this.GetSalesCount(index, extension)
        if (count === '') return ''
        var daypartName = this.day_part_reg
        var daypart = this.day_parts.filter(function (item) {
          return (
            item.business_extension === extension &&
            item.name !== daypartName &&
            (
              index >= parseInt(moment.utc(item.hour_from, 'HH:mm').format('H')) &&
              index <= parseInt(moment.utc(item.hour_to, 'HH:mm').format('H'))
            )
          )
        })
        daypartName = (daypart.length > 0) ? daypart[0].name : daypartName
        var hours = this.variable_hours.filter(function (item) {
          return (
            item.business_extension === extension &&
            item.day_part === daypartName &&
            (count >= item.guest_count_from && count <= item.guest_count_to)
          )
        })
        if (hours.length === 0 && daypartName !== this.day_part_reg) {
          daypartName = this.day_part_reg
          hours = this.variable_hours.filter(function (item) {
            return (
              item.business_extension === extension &&
              item.day_part === daypartName &&
              (count >= item.guest_count_from && count <= item.guest_count_to)
            )
          })
        }
        if (hours.length === 0) return ''
        return hours[0].crew_count
      },
      GetDifference (index, extension) {
        var sales = this.GetSalesCount(index, extension)
        if (sales === '') sales = 0
        var input = this.user_inputs[extension.toLowerCase()][0][index]
        if (input === '') return ''
        if (input === 0) return ''
        return (sales - input)
      },
      GetTotalHours (index) {
        var total = 0.0
        for (const i in this.totals) {
          if (!this.ShowSales(i)) { continue } // exclude fixed hours
          total = total + (this.totals[i][0][index] === '' ? 0 : this.totals[i][0][index])
        }
        return total > 0 ? total : ''
      },
      GetHoursSummary () {
        var total = 0.0
        for (var index = 0; index < 24; ++index) {
          var h = this.GetTotalHours(index)
          total = total + (h === '' ? 0 : h)
        }
        this.hours_summary = total
        return total
      },
      GetTotalFixedHours () {
        if (typeof this.totals.FixedHours === 'undefined') { return 0.0 }
        var total = 0.0
        for (var count = 0; count < 24; ++count) {
          var h = this.totals.FixedHours[0][count]
          total = total + (h === '' ? 0 : h)
        }
        this.fixed_hours = total
        return total
      },
      GetExtensionTotalHours (extension) {
        if (typeof this.totals[extension] === 'undefined') { return 0.0 }
        var total = 0.0
        for (var count = 0; count < 24; ++count) {
          var h = this.totals[extension][0][count]
          total = total + (h === '' ? 0 : h)
        }
        return total
      },
      GetTotalDifference (index) {
        var total = this.user_inputs.total_gc[0][index]
        if (total === '' || total === 0) return ''
        return (this.sales[index].HSPTAC - total)
      },
      GetCombinedGC (index) {
        var sales = this.sales[index].HSPTAC
        if (sales === 0) return ''
        var total = this.GetTotalHours(index)
        if (total === '') return ''
        return this.NumberWithComma1(sales / total)
      },
      CreateTotals (group) {
        var items = null
        this.totals[group] = JSON.parse(JSON.stringify(this.default_plot))
        items = this.records.filter(function (item) {
          return (
            item.channel === group && item.personnelidno !== ''
          )
        })
        if (items !== null) {
          for (const index in items) {
            if (items[index].schedule === '') {
              if (!Object.prototype.hasOwnProperty.call(this.advance_plot_parse, 'p' + items[index].uid)) {
                this.advance_plot_parse['p' + items[index].uid] = this.ParseJSON(items[index].advance_plot)
              }
              for (var n2 = 0; n2 < 24; ++n2) {
                if (Object.prototype.hasOwnProperty.call(this.advance_plot_parse['p' + items[index].uid], 'p' + (n2))) {
                  var p2 = parseFloat(this.advance_plot_parse['p' + items[index].uid]['p' + (n2)])
                  this.totals[group][0][n2] = (this.totals[group][0][n2] === '') ? p2 : (this.totals[group][0][n2] + p2)
                }
              }
            } else {
              var s = items[index].schedule.split('-')
              var min = parseInt(moment.utc(s[0], 'HH:mm').format('H'))
              var max = parseInt(moment.utc(s[1], 'HH:mm').format('H'))
              // if (max < min && max === 0) { max = 24 } // before GY update
              if (max < min && items[index].week_day_id === items[index].wid) { // GY update
                max = 24
              } else if (max < min && items[index].week_day_id !== items[index].wid) {
                min = 0
              }
              for (var n = 0; n < 24; ++n) {
                var p = (n >= min && n <= max) ? 1 : 0
                //
                if (p !== 0) {
                  if (n === parseInt(moment.utc(s[0], 'HH:mm').format('H'))) {
                    p = s[0].indexOf('30') > -1 ? 0.5 : p
                  }
                  if (n === parseInt(moment.utc(s[1], 'HH:mm').format('H'))) {
                    p = s[1].indexOf('30') > -1 ? 0.5 : 0
                  }
                }
                //
                this.totals[group][0][n] = (this.totals[group][0][n] === '') ? p : (this.totals[group][0][n] + p)
              }
            }
          }
        }
      },
      CreateTotalsTA () {
        this.totals.TA = JSON.parse(JSON.stringify(this.default_plot))
        for (const index in this.crew_time_availability) {
          var min = parseInt(moment.utc(this.crew_time_availability[index].start, 'HH:mm').format('H'))
          var max = parseInt(moment.utc(this.crew_time_availability[index].end, 'HH:mm').format('H'))
          if (max < min && max === 0) { max = 24 }
          for (var n = 0; n < 24; ++n) {
            var p = (n >= min && n <= max) ? 1 : 0
            //
            if (p !== 0) {
              if (n === parseInt(moment.utc(this.crew_time_availability[index].start, 'HH:mm').format('H'))) {
                p = this.crew_time_availability[index].start.indexOf('30') > -1 ? 0.5 : p
              }
              if (n === parseInt(moment.utc(this.crew_time_availability[index].end, 'HH:mm').format('H'))) {
                p = this.crew_time_availability[index].end.indexOf('30') > -1 ? 0.5 : 0
              }
            }
            //
            this.totals.TA[0][n] = (this.totals.TA[0][n] === '') ? p : (this.totals.TA[0][n] + p)
          }
        }
      },
      ComputeLabor () {
        // reset
        this.labor = 0.0
        this.night_diff = 0.0
        //
        for (const index in this.records) {
          if (this.records[index].personnelidno !== '') {
            var nd = 0.0
            if (this.records[index].schedule === '') {
              // if (item.advance_plot === '' || item.advance_plot === null) { return '' }
              // if (!Object.prototype.hasOwnProperty.call(this.advance_plot_parse, 'p' + item.uid)) { this.advance_plot_parse['p' + item.uid] = this.ParseJSON(item.advance_plot) }
              // if (Object.prototype.hasOwnProperty.call(this.advance_plot_parse['p' + item.uid], 'p' + (n - 1))) { return this.advance_plot_parse['p' + item.uid]['p' + (n - 1)] }
            } else {
              var s = this.records[index].schedule.split('-')
              var h = this.GetTimeSpan(s[0], s[1])
              this.records[index].base = this.records[index].rate * h
              this.records[index].base_cola = this.records[index].cola * h
              // compute night diff
              for (var n = 0; n < 24; n++) {
                if (n < 6 || n > 21) {
                  var p = ((n >= parseInt(moment.utc(s[0], 'HH:mm').format('H')) && n <= parseInt(moment.utc(s[1], 'HH:mm').format('H')))) ? 1 : 0
                  if (p === 1) {
                    if (n === parseInt(moment.utc(s[0], 'HH:mm').format('H'))) {
                      p = s[0].indexOf('30') > -1 ? 0.5 : p
                    }
                    if (n === parseInt(moment.utc(s[1], 'HH:mm').format('H'))) {
                      p = s[1].indexOf('30') > -1 ? 0.5 : 0
                    }
                  }
                  nd = nd + p
                }
              }
            }
            this.records[index].night_diff = this.records[index].rate * nd * 0.1
            //
            this.labor = this.labor + this.records[index].base + this.records[index].base_cola + this.records[index].night_diff
            this.night_diff = this.night_diff + this.records[index].night_diff
          }
        }
      },
      IsRecord (id) {
        return (id === '')
      },
      GetPlot (item, n) {
        if (item.schedule === '') {
          if (item.advance_plot === '' || item.advance_plot === null) { return '' }
          if (!Object.prototype.hasOwnProperty.call(this.advance_plot_parse, 'p' + item.uid)) { this.advance_plot_parse['p' + item.uid] = this.ParseJSON(item.advance_plot) }
          if (Object.prototype.hasOwnProperty.call(this.advance_plot_parse['p' + item.uid], 'p' + (n - 1))) { return this.advance_plot_parse['p' + item.uid]['p' + (n - 1)] }
          return ''
        } else {
          var s = item.schedule.split('-')
          var min = parseInt(moment.utc(s[0], 'HH:mm').format('H'))
          var max = parseInt(moment.utc(s[1], 'HH:mm').format('H'))
          // if (max < min && max === 0) { max = 24 } // before GY update
          if (max < min && item.week_day_id === item.wid) { // GY update
            max = 24
          } else if (max < min && item.week_day_id !== item.wid) {
            min = 0
          }
          var p = ((n - 1 >= min && n - 1 <= max)) ? '1' : ''
          if (p !== '') {
            if ((n - 1) === parseInt(moment.utc(s[0], 'HH:mm').format('H'))) {
              p = s[0].indexOf('30') > -1 ? '0.5' : p
            }
            if ((n - 1) === parseInt(moment.utc(s[1], 'HH:mm').format('H'))) {
              p = s[1].indexOf('30') > -1 ? '0.5' : ''
            }
          }
          return p
        }
      },
      GetPlotTA (item, n) {
        var min = parseInt(moment.utc(item.start, 'HH:mm').format('H'))
        var max = parseInt(moment.utc(item.end, 'HH:mm').format('H'))
        if (max < min && max === 0) { max = 24 }
        var p = ((n - 1 >= min && n - 1 <= max)) ? '1' : ''
        if (p !== '') {
          if ((n - 1) === parseInt(moment.utc(item.start, 'HH:mm').format('H'))) {
            if (item.start.indexOf('30') > -1) {
              p = 'h1'
            }
          }
          if ((n - 1) === parseInt(moment.utc(item.end, 'HH:mm').format('H'))) {
            if (item.end.indexOf('30') > -1) {
              p = 'h2'
            } else {
              p = ''
            }
          }
        }
        return p
      },
      ShowNewProjection () {
        if (!this.access.includes(this.roles.scheduler_manage)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.show_generate_projection = true
        this.starting_date = moment().format('YYYY-MM-DD')
      },
      FormatTime (t) {
        return moment(t, 'HHmm').format('HH:mm')
      },
      NumberWithComma (n) {
        if (isNaN(n)) { return 0 }
        var val = (n / 1).toFixed(2)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      NumberWithComma1 (n) {
        if (isNaN(n)) { return 0 }
        var val = (n / 1).toFixed(1)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      OnDateInput () {
        this.date_menu = false
        this.date_menu_from = false
        this.date_menu_to = false
      },
      GenerateProjection () {
        this.$store.commit('Notify', 'Generating Projection...')
        this.$apollo.mutate({
          mutation: CreateDocument,
          variables: {
            date: this.starting_date,
          },
        }).then((res) => {
          if (res.data) {
            this.$store.commit('CloseAlert', 'Data Projection has been created!')
            this.show_generate_projection = false
            if (res.data.CreateDocument.status === 'Ok') {
              this.documents = res.data.CreateDocument.data
              this.store_name = res.data.CreateDocument.store_name
              this.documents_hash = res.data.CreateDocument.hash
              this.GetRecords(res.data.CreateDocument.uid, 0)
            } else if (res.data.CreateDocument.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            } else {
              this.$store.commit('ShowError', res.data.CreateDocument.status)
            }
          }
        }).catch(error => {
          this.CheckError(error)
        })
      },
      ShowExport () {
        if (!this.access.includes(this.roles.scheduler_export)) {
          this.$store.commit('ShowError', 'Invalid Access!')
          return
        }
        this.filename = ''
        this.personnelidno = ''
        this.date_from = moment().format('YYYY-MM-DD')
        this.date_to = moment().format('YYYY-MM-DD')
        this.show_export = true
      },
      ExportToExcel () {
        const shift = 210
        this.generating = true
        this.filename = ''
        this.$apollo.mutate({
          mutation: ExportToExcel,
          variables: {
            personnelidno: this.personnelidno,
            date_from: this.date_from,
            date_to: this.date_to,
            type: shift,
          },
        }).then((res) => {
          if (res.data.ExportToExcel.status === 'Ok') {
            this.filename = res.data.ExportToExcel.data[0].filename
          } else if (res.data.ExportToExcel.status === '0') {
            this.CheckError({ message: 'Session expired!' })
          } else {
            this.$store.commit('ShowError', res.data.ExportToExcel.status)
          }
          this.generating = false
        }).catch(error => {
          this.CheckError(error)
          this.generating = false
        })
      },

      // #region Advance Plotting
      ShowAdvancePlot () {
        if (!this.edited_items) { return }
        var s = this.edited_items[0].time_availability.split('-')
        this.max_hours = this.GetTimeSpan(s[0], s[1])
        this.min_plot = this.GetTimeToInt(s[0], s[0])
        this.max_plot = this.GetTimeToInt(s[1], s[0])
        if (this.max_plot < this.min_plot && this.max_plot === 0) { this.max_plot = 24 }
        //
        this.advance_plot_input = []
        var plot = {}
        plot.trained_area = ''
        for (var n = 0; n < 24; ++n) {
          plot['p' + n] = ''
        }
        for (const index in this.edited_items) {
          this.advance_plot_input[index] = JSON.parse(JSON.stringify(plot))
          this.advance_plot_input[index].trained_area = this.edited_items[index].trained_area
          if (Object.prototype.hasOwnProperty.call(this.advance_plot_parse, 'p' + this.edited_items[index].uid)) {
            const p = this.advance_plot_parse['p' + this.edited_items[index].uid]
            for (var key in p) {
              this.advance_plot_input[index][key] = p[key]
            }
          }
        }
        this.show_advance_plot = true
        this.IsPlotValid()
      },

      ShowVersionHistory (item) {
        this.reference_number = item.ref
        this.nick_name = item.nick_name
        this.selected_uid = item.uid
        this.selected_item = 0
        this.loading_document_history = true
        this.document_history = []
        this.version_list = []
        this.skip_document_history = false
        this.$apollo.queries.DocumentHistory.refetch()
        this.show_version_history = true
      },
      ReloadHistory () {
        this.loading_document_history = true
        this.document_history = []
        this.skip_document_history = false
        this.$apollo.queries.DocumentHistory.refetch()
      },
      SaveAdvancePlot () {
        if (this.posted) { return }
        if (!this.IsPlotValid()) { return }
        this.UpdateScheduleAdvance()
      },
      CleanObject (obj) {
        var o = Object.fromEntries(
          Object.entries(obj)
            .filter(([_, v]) => v !== '')
            .map(([k, v]) => [k, v === Object(v) ? this.CleanObject(v) : v]),
        )
        delete o.trained_area
        return o
      },
      SetValueOnClick (idx, key) {
        if (this.advance_plot_input[idx][key] === '1') {
          this.advance_plot_input[idx][key] = '0.5'
        } else if (this.advance_plot_input[idx][key] === '0.5') {
          this.advance_plot_input[idx][key] = ''
        } else {
          this.advance_plot_input[idx][key] = '1'
        }
        this.IsPlotValid()
      },
      GetAdvancePlot (idx, id) {
        return this.advance_plot_input[idx][id]
      },
      IsPlotValid () {
        if (!this.edited_items) { this.isplot_valid = false; return false }
        var t = 0.0
        var min = -1.0
        var max = -1.0
        // validate plotting
        for (var n = 0; n < 24; ++n) {
          var plot = 0.0
          for (const index in this.advance_plot_input) {
            if (this.advance_plot_input[index]['p' + n] === '') { continue }
            plot = plot + Number(this.advance_plot_input[index]['p' + n])
          }
          if (plot > 0 && plot <= 1) {
            if (min < 0) { if (plot === 0.5) { min = n + 0.5 } else { min = n } } // set lower plot
            if (plot === 0.5) { max = n + 0.5 } else { max = n + 1 } // set higher plot
          }
          if (plot > 1) { this.isplot_valid = false; return false }
          t = t + plot
        }
        if (t < 4 || t > this.max_hours) { this.isplot_valid = false; return false } // minimum is 4hrs
        if (t !== (max - min)) { this.isplot_valid = false; return false } // total hours not tally to selected plot
        this.isplot_valid = true
        return true
      },
      UpdateScheduleAdvance () { // for advance plotting schedule
        const plot = this.CleanObject(this.advance_plot_input)
        var data = []
        for (const index in this.edited_items) {
          data.push({
            uid: this.edited_items[index].uid,
            advance_plot: JSON.stringify(plot[index]),
          })
        }
        this.$store.commit('Notify', '')
        this.$apollo.mutate({
          mutation: UpdateScheduleAdvance,
          variables: {
            hash: this.records_hash,
            data: JSON.stringify(data),
          },
        }).then((res) => {
          if (res.data.UpdateScheduleAdvance.status === 'Ok') {
            // update ui data
            for (const index in this.edited_items) {
              this.edited_items[index].schedule = ''
              this.edited_items[index].advance_plot = JSON.stringify(plot[index])
              this.advance_plot_parse['p' + this.edited_items[index].uid] = plot[index]
              this.edited_items[index].hours = Object.keys(plot[index]).reduce((sum, key) => sum + parseFloat(plot[index][key] || 0), 0)
              if (this.edited_items[index].meal !== '-') { this.edited_items[index].meal = res.data.UpdateScheduleAdvance.meal_update }
            }
            this.meal_a = res.data.UpdateScheduleAdvance.meal[0].meal_a
            this.meal_b = res.data.UpdateScheduleAdvance.meal[0].meal_b
            this.$store.commit('CloseAlert', '')
            this.show_advance_plot = false
            this.UpdateSummary()
          } else if (res.data.UpdateScheduleAdvance.status === '0') {
            this.CheckError({ message: 'Session expired!' })
          } else {
            this.$store.commit('ShowError', res.data.UpdateScheduleAdvance.status)
          }
        }).catch(error => {
          this.CheckError(error)
        })
      },
      ParseJSON (o) {
        try {
          return JSON.parse(o)
        } catch (e) {
          return ''
        }
      },
      // #endregion Advance Plotting

    },
    apollo: {
      Documents: {
        error (error) {
          this.loading_document = false
          this.CheckError(error)
        },
        query: Documents,
        variables () {
          return {
            per_page: this.options.itemsPerPage || 10,
            page: this.options.page || 1,
          }
        },
        skip () {
          return this.skip_document
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.Documents.status === 'Ok') {
              this.documents = data.Documents.data
              this.store_name = data.Documents.store_name
              this.documents_hash = data.Documents.hash
              this.total = data.Documents.total
              this.loading_document = false
              this.skip_document = true
            } else if (data.Documents.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            } else {
              this.$store.commit('ShowError', data.Documents.status)
            }
          }
        },
      },
      DocumentRecords: {
        error (error) {
          this.loading_records = false
          this.CheckError(error)
        },
        query: DocumentRecords,
        variables () {
          return {
            uid: this.document_uid,
            hash: this.documents_hash,
            week_day_id: this.week_day_id,
          }
        },
        skip () {
          return this.skip_records
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.DocumentRecords.status === 'Ok') {
              this.posted = data.DocumentRecords.posted
              this.locked = data.DocumentRecords.locked
              this.sales = data.DocumentRecords.sales
              this.sales_date = moment(this.sales[0].HSPDAY).format('dddd MMM DD, YYYY')
              this.sales_count = data.DocumentRecords.sales_count
              this.gross_sales = data.DocumentRecords.gross_sales
              this.records = data.DocumentRecords.data
              this.records_hash = data.DocumentRecords.hash
              this.business_extensions = data.DocumentRecords.business_extensions
              this.day_parts = data.DocumentRecords.day_parts
              this.variable_hours = data.DocumentRecords.variable_hours
              this.meal_a = 0
              this.meal_b = 0
              this.stations = data.DocumentRecords.stations
              // create sort
              for (const index in this.records) {
                if (this.records[index].week_day_id !== this.records[index].wid) {
                  this.records[index].start = '00:00' // cross over
                } else {
                  this.records[index].start = this.records[index].schedule !== '' ? this.records[index].schedule.split('-')[0] : ''
                }
                this.records[index].end = this.records[index].schedule !== '' ? this.records[index].schedule.split('-')[1] : ''
              }
              //
              if (data.DocumentRecords.meal) {
                if (data.DocumentRecords.meal[0].meal_a) {
                  this.meal_a = data.DocumentRecords.meal[0].meal_a
                }
                if (data.DocumentRecords.meal[0].meal_b) {
                  this.meal_b = data.DocumentRecords.meal[0].meal_b
                }
              }
              if (data.DocumentRecords.user_input && Object.keys(JSON.parse(data.DocumentRecords.user_input)).length > 0) {
                this.user_inputs = JSON.parse(data.DocumentRecords.user_input)
                this.expense = Number(this.user_inputs.expense)
              } else {
                this.user_inputs = {}
                // this.user_inputs.total_gc = Object.assign([], this.default_plot)
                this.user_inputs.expense = 0.0
                this.user_inputs.total_gc = JSON.parse(JSON.stringify(this.default_plot))
                this.user_inputs.total_hours = JSON.parse(JSON.stringify(this.default_plot))
                for (const index in this.business_extensions) {
                  this.user_inputs[this.business_extensions[index].name.toLowerCase()] = JSON.parse(JSON.stringify(this.default_plot))
                }
                var n = JSON.stringify(this.user_inputs)
                this.user_inputs = JSON.parse(n)
              }
              this.UpdateSummary()
              if (!this.posted && this.access.includes(this.roles.scheduler_manage)) {
                this.GetManagers()
              } else {
                this.loading_employees = false
                this.loading_stations = false
              }
            } else if (data.DocumentRecords.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            } else {
              this.$store.commit('ShowError', data.DocumentRecords.status)
            }
            this.loading_records = false
            this.skip_records = true
          }
        },
      },
      DocumentHistory: {
        error (error) {
          this.loading_document_history = false
          this.CheckError(error)
        },
        query: DocumentHistory,
        variables () {
          return {
            uid: this.selected_uid,
            hash: this.documents_hash,
            version: (this.version_list.length === 0) ? null : this.version_list[this.selected_item].version,
            get_list: this.version_list.length === 0,
          }
        },
        skip () {
          return this.skip_document_history
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.DocumentHistory.status === 'Ok') {
              this.document_history = data.DocumentHistory.data
              if (data.DocumentHistory.list) {
                this.version_list = data.DocumentHistory.list
                for (const index in this.version_list) {
                  this.version_list[index].date = this.GetLongDateFormat(this.version_list[index].date)
                }
              }
            } else if (data.DocumentHistory.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            } else {
              this.$store.commit('ShowError', data.DocumentHistory.status)
            }
            this.loading_document_history = false
            this.skip_document_history = true
          }
        },
      },
      GetManagers: {
        error (error) {
          this.loading_employees = false
          this.loading_stations = false
          this.CheckError(error)
        },
        query: GetManagers,
        variables () {
          return {
            week_day_id: this.week_day_id,
          }
        },
        skip () {
          return this.skip_employees
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data.GetManagers.status === 'Ok') {
              this.employees = data.GetManagers.data
              this.employees_hash = data.GetManagers.hash
              this.stations = data.GetManagers.stations
              this.stations_b = JSON.parse(JSON.stringify(this.stations))
              this.station_hash = data.GetManagers.station_hash
              this.station_hash_b = data.GetManagers.station_hash
            } else if (data.GetManagers.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            } else {
              this.$store.commit('ShowError', data.GetManagers.status)
            }
            this.loading_employees = false
            this.loading_stations = false
            this.skip_employees = true
          }
        },
      },
      CrewTimeAvailability: {
        error (error) {
          this.loading_crew_time_availability = false
          this.CheckError(error)
        },
        query: CrewTimeAvailability,
        variables () {
          return {
            uid: this.document_uid,
            hash: this.documents_hash,
            week_day_id: this.week_day_id,
          }
        },
        skip () {
          return this.skip_crew_time_availability
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data.CrewTimeAvailability.status === 'Ok') {
              this.crew_time_availability = data.CrewTimeAvailability.data
              this.loading_crew_time_availability = false
              this.skip_crew_time_availability = true
              this.CreateTotalsTA()
            } else if (data.CrewTimeAvailability.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            } else {
              this.$store.commit('ShowError', data.CrewTimeAvailability.status)
            }
          }
        },
      },
      AvailableCrew: {
        error (error) {
          this.loading_available_crew = false
          this.loading_stations = false
          this.CheckError(error)
        },
        query: AvailableCrew,
        variables () {
          return {
            uid: this.record_uid,
            hash: this.records_hash,
            week_day_id: this.week_day_id,
          }
        },
        skip () {
          return this.skip_available_crew
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data.AvailableCrew.status === 'Ok') {
              this.available_crew = data.AvailableCrew.data
              this.crew_filtered = JSON.parse(JSON.stringify(data.AvailableCrew.data))
              this.crew_hash = data.AvailableCrew.hash
              this.stations = data.AvailableCrew.stations
              this.station_hash = data.AvailableCrew.station_hash
            } else if (data.AvailableCrew.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            } else {
              this.$store.commit('ShowError', data.AvailableCrew.status)
            }
            this.loading_available_crew = false
            this.loading_stations = false
            this.skip_available_crew = true
          }
        },
      },
      GetJobRotation: {
        error (error) {
          this.loading_jobrotation = false
          this.CheckError(error)
        },
        query: GetJobRotation,
        variables () {
          return {
            uid: this.document_uid,
            hash: this.documents_hash,
          }
        },
        skip () {
          return this.skip_jobrotation
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetJobRotation.status === 'Ok') {
              this.jobrotation = data.GetJobRotation.jobrotation
              this.starting_date = data.GetJobRotation.date
              this.without_schedule = data.GetJobRotation.without_schedule
              this.loading_jobrotation = false
              this.skip_jobrotation = true
            } else if (data.GetJobRotation.status === '0') {
              this.CheckError({ message: 'Session expired!' })
            } else {
              this.$store.commit('ShowError', data.GetJobRotation.status)
            }
          }
        },
      },
      GetScheduleSummary: {
        error (error) {
          this.loading_summary = false
          this.CheckError(error)
        },
        query: GetScheduleSummary,
        variables () {
          return {
            date: moment().format('YYYY-MM-DD'),
          }
        },
        skip () {
          return this.skip_summary
        },
        result ({ data, loading }) {
          if (!loading) {
            if (data && data.GetScheduleSummary) {
              this.loading_summary = false
              this.skip_summary = true
              var sched = this.ParseJSON(data.GetScheduleSummary.data)
              var hasHeader = false
              for (const index in sched) {
                var item = {}
                for (var key in sched[index]) {
                  if (!hasHeader) {
                    if (key.toLowerCase() === 'store') {
                      this.headers_summary.push({
                        text: key, value: key, class: 'title',
                      })
                    } else {
                      this.headers_summary2.push({
                        text: key.replace('_', ' '), value: key, class: 'title',
                      })
                      this.headers_summary.push({
                        text: 'Crew', value: key + 'crew', class: 'title',
                      })
                      this.headers_summary.push({
                        text: 'Hours', value: key + 'hours', class: 'title',
                      })
                    }
                  }
                  if (key.toLowerCase() === 'store') {
                    item[key] = sched[index][key]
                  } else {
                    item[key + 'crew'] = sched[index][key][0]
                    item[key + 'hours'] = Math.round(sched[index][key][1])
                  }
                }
                this.summary.push(item)
                hasHeader = true
              }
            }
          }
        },
      },
    },
  }
</script>
